import $ from 'jquery';
// import 'select2';
/* global x5script */

// import 'flatpickr';
import 'owl.carousel';

class Wizard {
  constructor() {
    this.body = $('body');
    this.hasQuoteBlock = this.body.hasClass('has-quote-calc');
    this.wizard = $('.js-wizard');

    if (!this.wizard.length && !this.hasQuoteBlock) {
      return;
    }

    // Localize options
    this.isPartnerSite = x5script.isPartnerSite;
    this.insuranceTypes = x5script.wizardInsuranceTypes;
    this.insuranceTypeSlug = x5script.wizardInsuranceType;
    this.insuranceTarget = x5script.wizardInsuranceTarget;
    this.provinceOptions = x5script.provinceOptions;
    this.coverageOptions = x5script.wizardCoverageOptions;
    this.coverageValues = x5script.wizardCoverageValues;
    this.termValues = x5script.wizardTermValues;
    this.termOptions = x5script.wizardTermOptions;
    this.offersLabelsIcons = x5script.wziardOffersLabelsIcons;
    this.companies = x5script.wizardCompanies;
    this.companiesOnTop = x5script.wizardCompaniesOnTop;
    this.currency = x5script.wizardCurrency;
    this.infusionsoftEnable = x5script.infusionsoftEnable;
    this.quoteProgressLabels = x5script.quoteProgress;
    this.dateFormat = x5script.dateFormat;
    this.dateTimeFormat = x5script.dateTimeFormat;
    this.firstDayOfWeek = x5script.firstWeekDay;
    this.formSecurityNonce = x5script.security;
    this.ajaxurl = x5script.ajaxurl;
    this.quoteApiUrl = x5script.wizardQuoteApiUrl;
    this.generalErrorMsg = x5script.wizardErrorMessage;
    this.offerLabels = x5script.wizardOfferLabels;
    this.locale = x5script.locale;
    this.wizardCompareData = x5script.wizardCompare;
    this.closeIcon = x5script.closeIcon;
    this.benePrimaryHeader = x5script.wizardBenePrimary;
    this.beneSecondaryHeader = x5script.formBeneSecondary;
    this.minuteText = x5script.minute;
    this.minutesText = x5script.minutes;
    this.loaderTips = x5script.wizardLoaderTips;
    this.recsLabels = x5script.wizardRecs;

    // Elements
    this.wizardPattern = $('.js-wizard-icon');
    this.loader = this.wizard.find('.js-wizard-loader');
    this.loaderTip = this.loader.find('.js-wizard-loader-tip');
    this.helpBar = this.wizard.find('.js-wizard-help-bar');
    this.phoneNumberField = this.wizard.find('input.js-phone-number');

    this.steps = this.wizard.find('.js-wizard-steps');
    this.stepButton = this.steps.find('.js-wizard-button');
    this.stepBackButton = this.steps.find('.js-wizard-step-back-btn');
    this.form = this.wizard.find('.js-wizard-form');
    this.formBlock = $('form.js-wizard-form-block');
    this.formBlockForm = null;
    this.formBlockWizard = null;
    this.wizardBlockCalculateButon = null;
    this.isCompare =
      this.wizard.hasClass('is-compare') ||
      sessionStorage.getItem('compareUrlQuery') !== null;
    this.formSubmitBtn = this.form.find('.js-wizard-calculate');
    this.formRecommendations = this.form.find('.js-wizard-form-rec');
    this.formRecs = this.formRecommendations.find('.js-wizard-form-recs');
    this.formRecsBtn = this.formRecommendations.find(
      '.js-wizard-form-recs-btn',
    );
    this.formRecValue = this.formRecommendations.find(
      '.js-wizard-form-rec-value strong',
    );
    this.formRecsAssumptions = this.formRecommendations.find(
      '.js-wizard-form-recs-assumptions',
    );
    this.formRecsAssumptionsBtn = this.formRecommendations.find(
      '.js-wizard-form-recs-assumptions-btn',
    );
    this.formRecsAssumptionsClose = this.formRecommendations.find(
      '.js-wizard-form-recs-assumptions-close',
    );
    // this.flatpickrElement = this.wizard.find('.js-flatpickr');
    this.conditionals = this.steps.find('.is-conditional');
    this.conditionalFields = this.wizard.find('.js-form-conditional-fields');
    this.dynamicFormFields = this.wizard.find('.js-form-dynamic-section');
    this.repeaterFormFields = this.wizard.find('.js-form-repeater');
    this.thankYouContainer = this.wizard.find('.js-wizard-step-thankyou');

    this.contactMethodFields = this.wizard.find(
      'input[type="radio"][name="wizard-contact-via"], input[type="radio"][name="qtn-contact-via"]',
    );

    this.filters = this.wizard.find('.js-wizard-filters');
    this.filterToggleButton = this.filters.find('.js-filter-toggle-button');
    this.coverageSlider = $('.js-wizard-filter-coverage');
    this.coverageSliderObject = null;
    this.termFilter = this.filters.find('.js-wizard-filter-term');
    this.ratesFilter = this.filters.find('.js-wizard-filter-rates');
    this.partnerModal = $('.js-wizard-partner-modal');
    this.partnerForm = this.partnerModal.find('.js-wizard-partner-form');
    this.peopleFilter = this.filters.find('.js-wizard-filter-people');
    this.joinedSection = this.wizard.find('.js-wizard-joined');
    this.partnerFields = this.wizard.find('.js-form-partner-fields');

    this.offersHeader = this.wizard.find('.js-wizard-offers-header');
    this.offersContainer = this.wizard.find('.js-wizard-offers');

    this.compareAll = this.wizard.find('.js-wizard-compare-all');
    this.compareTable = $('.js-wizard-compare-table');
    this.compareTableHeaders = this.compareTable.find(
      '.js-wizard-compare-table-headers',
    );
    this.compareTableData = this.compareTable.find(
      '.js-wizard-compare-table-data',
    );
    this.compareOffersButton = this.wizard.find('.js-wizard-compare-button');
    this.compareAllCheckbox = this.wizard.find(
      '.js-wizard-compare-all input[type="checkbox"]',
    );
    this.compareBackButton = this.wizard.find('.js-wizard-compare-back');

    this.qtn = this.wizard.find('.js-wizard-qtn');
    this.qtnOfferLogo = this.qtn.find('.js-wizard-qtn-heading-logo');
    this.qtnOffer = this.qtn.find('.js-wizard-qtn-offer');
    this.qtnForm = this.qtn.find('.js-wizard-qtn-form');
    this.qtnFormBtn = this.qtnForm.find('.js-wizard-qtn-form-btn');
    this.qtnFormBackBtn = this.qtnForm.find('.js-wizard-qtn-form-back-btn');
    this.qtnProgressBar = this.wizard.find('.js-wizard-qtn-progress-bar');
    this.qtnSummary = this.wizard.find('.js-wizard-qtn-summary');
    this.qtnTimeLeft = this.wizard.find('.js-wizard-qtn-time-left');

    this.quoteResumeStep = $('.js-wizard-step[data-wizard-quote-resume]');

    // Variables
    this.window = window;

    this.formFields = {};
    this.formFieldsTypes = {};
    this.formFieldsOptional = [];
    this.quoteParams = [];
    this.recommendedData = {};
    this.infusionsoftData = { customFields: {} };
    this.infusionsoftContactId = 0;
    this.infusionsoftLeadSourceId = 0;
    this.infusionsoftProgress = null;
    this.emailData = {};
    this.offers = [];
    this.offersToCompare = [];
    this.offerAppliedFor = {};
    this.offerCompanyCode = null;
    this.qtnFormFields = {};
    this.qtnFormFieldsTypes = {};
    this.qtnFormFieldsOptional = [];
    this.qtnFormFieldsForSummary = {};
    this.qtnHasDocusign = false;
    this.docusignDocumentId = null;
    this.docusignData = {};
    this.resumeQuotedata = {};
    this.resumeQuoteUsed = 'no';
    this.quoteResumeId = 0;
    this.sendQtnLink = 'no';
    this.partnerFormFields = {};
    this.partnerOffers = [];
    this.partnerQuoteParams = [];
    this.joinedOffers = [];
    this.notMatchedOffers = [];
    this.originalOffers = [];
    this.quoteResume = {
      data: {},
      rowId: this.getFromSessionStorage('qrRid'),
      link: null,
    };
    this.quoteResumeDbData = x5script.resumeQuoteData;

    this.qtnMaxLengths = {
      WAWA: {
        'qtn-occupation': 110,
        'qtn-employer-name': 85,
        'qtn-insurance-reason-other': 95,
        'qtn-name-change-previous': 50,
        'qtn-city': 60,
        'qtn-street': 100,
      },
      RBCL: {
        'qtn-street': 38,
        'qtn-city': 38,
        'qtn-phone': 20,
        'qtn-insurance-purpose-other': 35,
        'qtn-occupation': 36,
        'qtn-employer-name': 25,
        'qtn-nature-of-business': 23,
        'qtn-duties-of-business': 33,
        'qtn-employer-how-long': 20,
        'qtn-finance-income-other-sources-1': 70,
        'qtn-finance-income-other-sources-2': 70,
        'qtn-ei-describe': 33,
        'qtn-travel-abroad-country': 35,
        'qtn-travel-abroad-length': 50,
        'qtn-travel-abroad-reason': 100,
        'qtn-travel-abroad-2-country': 35,
        'qtn-travel-abroad-2-length': 50,
        'qtn-travel-abroad-2-reason': 100,
        'qtn-sport-type': 50,
        'qtn-sport-details': 250,
        'qtn-insurance-modified-reason': 30,
        'qtn-criminal-details': 180,
        'qtn-driving-offence-licence-number': 20,
      },
    };

    this.wizardStepsOrder = ['1', '2', '3', '5', '6'];

    this.conditionalElements = null;
    this.AllConditionalElements = this.steps.find(
      `.is-conditional[data-wizard-condition-type]`,
    );
    this.wizardType = null;
    this.wizardApplyType = null;
    this.submitting = false;
    this.sliderLoaded = false;

    this.quoteType = this.wizard.data('itt') || 'wizard';
    this.quoteProgress = this.quoteProgressLabels.offersList;
    this.shortQuoteType = null;

    this.isInstantQuote = this.quoteType === 'instant-quote';
    this.isContactQuote = this.quoteType === 'quote';
    this.isCalculateQuote = this.quoteType === 'calculate-quote';

    this.insuranceType = this.insuranceTypes[this.insuranceTypeSlug];
    this.isCriticalIllnessQuote = this.insuranceTypeSlug === 'critical-illness';
    this.isNoMedicalQuote = this.insuranceTypeSlug === 'no-medical-insurance';

    this.gclid = this.wizard.data('gclid');

    this.init();

    if (this.wizard.data('resume') === 'yes') {
      if (!this.quoteResume.rowId) {
        if (this.quoteResumeDbData.id) {
          this.quoteResume.rowId = this.quoteResumeDbData.id;
          this.setSessionStorage('qrRid', this.quoteResume.rowId);
        }
      }

      this.showLoader(this.loaderTips.resuming);

      setTimeout(() => {
        this.resumeQuote();
      }, 1000);
    }
  }

  init() {
    this.conditionalSections();
    this.conditionalFormFields();
    this.manageDynamicFormFields();
    this.formatFormFields();
    this.manageRepeaterFormFields();
    // this.datePicker();
    this.dateField();

    this.goStepBack();
    this.go2step2or6orFinish();
    this.applyForOffer();
    this.phoneNumberFormat();

    this.filtersToggle();
    this.resumeQuoteSetup();
    this.joinedButtonsHandler();
    this.contactMethodHandler();

    if (this.hasQuoteBlock) {
      this.coverageFilter();
      this.formBlockProcess();
    } else {
      this.pageRefreshConfirm();
      this.processIsCompare();
    }
  }

  setSessionStorage(name, value) {
    this.window.sessionStorage.setItem(name, value);
  }

  getFromSessionStorage(name) {
    return this.window.sessionStorage.getItem(name);
  }

  removeFromSessionStorage(name) {
    return this.window.sessionStorage.removeItem(name);
  }

  contactMethodHandler() {
    if (this.contactMethodFields.length && this.phoneNumberField.length) {
      this.contactMethodFields.on('change', e => {
        if (e.target.value === 'Phone') {
          this.formFieldsOptional.filter(v => !v.match(/phone/));
          this.formFieldsOptional = this.formFieldsOptional.filter(
            v => !v.match(/phone/),
          );
          this.qtnFormFieldsOptional = this.qtnFormFieldsOptional.filter(
            v => !v.match(/phone/),
          );
          this.phoneNumberField.removeClass('is-optional');
        } else {
          this.phoneNumberField.addClass('is-optional');
        }
      });
    }
  }

  processIsCompare() {
    if (this.isCompare) {
      this.wizard.addClass('is-compare');
      this.wizard
        .find('.js-wizard-button[data-wizard-type="apply-contact"]')
        .parent()
        .hide();
      const urlQuery =
        this.window.location.search ||
        sessionStorage.getItem('compareUrlQuery');

      const urlParams = new URLSearchParams(urlQuery);
      const requiredParams = [
        'birthYear',
        'birthMonth',
        'birthday',
        'sex',
        'smoker',
        'province',
        'category',
        'faceAmount',
        'mode',
        'healthClass',
      ];
      const empty = [];
      const quoteParams = {};

      for (let i = 0; i < requiredParams.length; i += 1) {
        const param = requiredParams[i];
        if (!urlParams.has(param)) {
          empty.push(param);
        } else {
          let paramValue = urlParams.get(param);
          if (param === 'smoker') {
            paramValue = paramValue === '1';
          }
          quoteParams[param] = paramValue;
          urlParams.delete(param);
        }
      }
      urlParams.delete('compare');

      urlParams.forEach((value, key) => {
        this.formFields[key] = value;
      });

      this.window.history.replaceState(
        {},
        document.title,
        window.location.href.split('?')[0],
      );

      if (!empty.length) {
        sessionStorage.setItem('compareUrlQuery', urlQuery);
        const quoteButton = $('.js-wizard-button[data-wizard-type="expert"]');

        if (quoteButton.length) {
          this.setNextStep(3);
          this.getCurrentStep();
          this.quoteParams = quoteParams;
          this.stepBackButton.hide();

          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');

            this.nextStep.fadeIn(500, () => {
              this.nextStep.addClass('is-active');
              this.callQuotesApi();
            });
          });
        }
      }
    }
  }

  formBlockProcess() {
    const CAValues = Object.keys(this.coverageValues);
    $.each(this.formBlock, (i, el) => {
      this.formBlockForm = $(el);
      this.formBlockWizard = this.formBlockForm.closest('.js-wizard');
      this.formBlockresult = $('.js-wizard-form-block-result');
      this.wizardBlockCalculateButon = this.formBlockWizard.find(
        '.js-wizard-block-calculate',
      );
      const CAValueElement = this.formBlock.find('.js-wizard-filter-value');

      let debounce = null;
      this.formBlockForm.off('input', 'input, select');
      this.formBlockForm.on('input', 'input, select', e => {
        clearTimeout(debounce);

        const field = $(e.currentTarget);
        if (field.attr('name') === 'wizard-coverage') {
          const valueIndex = CAValues.indexOf(field.val());
          this.coverageSliderObject.slider('value', valueIndex);
          const coverageValueData = this.coverageValues[field.val()] || {};

          if (coverageValueData.label) {
            CAValueElement.text(`${coverageValueData.label}`);
          }
        }
        // this.formBlockresult.text(`${this.currency}__`);
        this.go2step3();
        debounce = setTimeout(() => {
          this.formBlockForm.trigger('submit');
        }, 500);
      });
    });
  }

  processQuoteBlock() {
    this.formBlockHasEmptyValues = Object.entries(this.formFields).filter(
      ([, v]) => v === '',
    );

    if (!this.formBlockHasEmptyValues.length) {
      this.loader = this.formBlockWizard.find('.js-wizard-loader');
      this.showLoader('');

      $.post(
        this.ajaxurl,
        {
          action: 'x5_wizard_form_validation',
          security: this.formSecurityNonce,
          fields: this.formFields,
          fieldsTypes: this.formFieldsTypes,
        },
        response => {
          if (response.ok) {
            this.quoteParams = response.quoteParams;

            if (this.formFields['wizard-it'] === 'critical-illness') {
              this.quoteParams.NewCategory = this.quoteParams.category;
              this.quoteParams.CompLife = 'COMPLIFECI/';
            }

            $.ajax({
              url: this.quoteApiUrl,
              type: 'POST',
              headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
              },
              data: JSON.stringify(this.quoteParams),
              success: offers => {
                this.offers = Wizard.prepareOffers(offers);
                this.hideLoader();

                this.submitting = false;

                if (this.offers.length) {
                  const bestPrice = this.offers.reduce(
                    (min, p) => (p.premium < min ? p.premium : min),
                    this.offers[0].premium,
                  );

                  this.formBlockresult.text(
                    `${this.formatNumber(bestPrice, 2, 2)}`,
                  );

                  this.wizardBlockCalculateButon.attr('disabled', false);

                  this.wizardBlockCalculateButon.off('click');
                  this.wizardBlockCalculateButon.on('click', () => {
                    this.window.location.replace(response.compareUrl);
                  });
                } else {
                  this.formBlockresult.text(this.offerLabels.noOffers);
                  this.wizardBlockCalculateButon.attr('disabled', true);
                }
              },
              error: res => {
                // eslint-disable-next-line no-console
                console.log('error api', res);
                this.displayGeneraError();
              },
            });
          } else {
            this.displayGeneraError();
          }
        },
      ).fail((xhr, status, error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.displayGeneraError();
      });
    } else {
      this.submitting = false;
    }
  }

  resumeQuote() {
    const data = this.quoteResumeDbData;

    if (this.wizard.data('resume-invalid') === 'yes') {
      this.generalErrorMsg = data.error;
      this.displayGeneraError();

      if (data.redirectUrl) {
        setTimeout(() => {
          this.window.location.replace(data.redirectUrl);
        }, 5000);
      }
      return;
    }

    this.insuranceType = data.insurance_type.name;
    this.insuranceTypeSlug = data.insurance_type.slug;
    this.insuranceTarget = data.insurance_type.target || 'wizard';
    this.isCriticalIllnessQuote = data.insurance_type.ci === 'true';
    this.formFields = data.form_fields;
    this.quoteParams = data.quote_data;
    this.offerAppliedFor = data.offer_applied_for;
    this.offerCompanyCode = this.offerAppliedFor.companyCode;
    this.partnerFormFields = data.partner_form_fields;
    this.partnerQuoteParams = data.partner_quote_data;
    this.qtnFormFields = data.qtn_data;

    this.isCriticalIllnessQuote =
      data.insurance_type_slug === 'critical-illness';

    this.conditionalElements = this.steps.find(
      '.is-conditional[data-wizard-condition-type="expert"]',
    );

    if (Object.keys(this.formFields).length) {
      this.populateFields(this.formFields, this.form);
    }

    if (Object.keys(this.partnerFormFields).length) {
      this.peopleFilter.find('input[type="radio"]').removeAttr('checked');
      this.peopleFilter
        .find('input[type="radio"][value="partner"]')
        .prop('checked', true);

      this.populateFields(this.partnerFormFields, this.partnerForm);
    }

    if (Object.keys(this.qtnFormFields).length) {
      this.populateFieldsPrepareBeneficiary('primary');
      this.populateFieldsPrepareBeneficiary('secondary');

      this.populateFields(this.qtnFormFields, this.qtnForm);
    }

    switch (data.resume_at) {
      case 'qtn':
        this.setNextStep(6);
        this.startQuestionnaire();
        break;
      default:
        this.setStepBack(2);
        this.setNextStep(3);
        break;
    }

    this.stepBackButton.show();
    this.setupConditionalElements();
    this.go2step3();
    this.callQuotesApi();
    this.partnerFormProcess();
    if (Object.keys(this.partnerFormFields).length) {
      this.callQuotesApiPartner();
    }
  }

  populateFieldsPrepareBeneficiary(type) {
    const regex = new RegExp(`bene-${type}-first-name`);

    this.populateFieldsBeneficiary = Object.keys(this.qtnFormFields).filter(
      key => key.match(regex),
    );

    if (this.populateFieldsBeneficiary.length > 1) {
      const btn = this.qtnForm.find(
        `.js-form-repeater-bene-${type} .js-form-repeater-add`,
      );

      if (btn.length) {
        for (let i = 1; i < this.populateFieldsBeneficiary.length; i += 1) {
          btn.trigger('click');
        }
      }
    }
  }

  populateFields(formFields, form) {
    this.populateFieldsData = formFields;

    $.each(this.populateFieldsData, (k, v) => {
      const field = form.find(`[name=${k}]`);

      if (field.length) {
        const isSelect = field.hasClass('js-select2');

        if (isSelect) {
          field.val(v).trigger('change');
        } else {
          const type = field.attr('type');

          switch (type) {
            case 'radio':
              $.each(field, (i, el) => {
                if ($(el).val() === v) {
                  $(el)
                    .prop('checked', true)
                    .trigger('change');
                } else {
                  $(el).prop('checked', false);
                }
              });
              break;
            default:
              field.val(v).trigger('input');
              break;
          }
        }
      }
    });
  }

  resumeQuoteSetup() {
    if (this.quoteResumeStep.length) {
      this.quoteResumeId = this.quoteResumeStep.data('wizard-quote-resume');

      this.showLoader(this.loaderTips.qtn);

      $.post(
        this.ajaxurl,
        {
          action: 'x5_wizard_resume_quote',
          security: this.formSecurityNonce,
          row_id: this.quoteResumeId,
        },
        response => {
          if (response.ok) {
            this.resumeQuotedata = response.data;
            this.nextStep = this.quoteResumeStep;

            if (this.resumeQuotedata.offer_applied_for !== '') {
              this.offerAppliedFor = JSON.parse(
                this.resumeQuotedata.offer_applied_for,
              );
              this.offerCompanyCode = this.offerAppliedFor.companyCode;
            }
            this.startQuestionnaire();
          } else {
            this.generalErrorMsg = response.error;
            this.displayGeneraError();
          }
        },
      ).fail((xhr, status, error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.displayGeneraError();
      });
    }
  }

  joinedButtonsHandler() {
    const buttons = this.joinedSection.find('.js-wizard-joined-button');

    if (buttons.length) {
      buttons.on('click', e => {
        const button = $(e.currentTarget);
        const type = button.attr('data-type');

        if (type === 'partner') {
          this.partnerModal.addClass('show');
        } else if (type === 'me') {
          const backButton = this.steps.find('.js-wizard-step-back-btn');
          backButton.trigger('click');
        }
      });
    }
  }

  qtnMaxLengthFields() {
    const maxLengths = this.qtnMaxLengths[this.offerCompanyCode];

    if (typeof maxLengths !== 'undefined') {
      $.each(maxLengths, (fieldName, maxLen) => {
        const field = this.qtnForm.find(`input[name="${fieldName}"]`);

        if (field.length) {
          // const label = field.parent().find('label');
          field.attr('maxlength', maxLen);

          // if (label.length) {
          //   const labelText = `${label.text()} (max. ${maxLen} characters)`;
          //   label.text(labelText);
          //   field.attr('placeholder', labelText);
          // }
        }
      });
    }
  }

  showLoader(tip = '') {
    this.loaderTip.text(tip);
    this.loader.show();
  }

  hideLoader() {
    this.loaderTip.text('');
    this.loader.hide();
  }

  phoneNumberFormat() {
    this.phoneNumberField.on('keyup', e => {
      const field = $(e.currentTarget);
      const { value } = e.currentTarget;
      let newValue = value.replace(/\D/g, '').substring(0, 10);
      // Backspace and Delete keys
      const deleteKey = e.keyCode === 8 || e.keyCode === 46;
      const len = value.length;
      if (len === 0) {
        newValue = value;
      } else if (len < 3) {
        newValue = `(${newValue}`;
      } else if (len === 3) {
        newValue = `(${newValue}${deleteKey ? '' : ') '}`;
      } else if (len < 6) {
        newValue = `(${newValue.substring(0, 3)}) ${newValue.substring(3, 6)}`;
      } else if (len === 6) {
        newValue = `(${newValue.substring(0, 3)}) ${newValue.substring(3, 6)}${
          deleteKey ? '' : '-'
        }`;
      } else {
        newValue = `(${newValue.substring(0, 3)}) ${newValue.substring(
          3,
          6,
        )}-${newValue.substring(6, 10)}`;
      }
      field.val(newValue);
    });
  }

  /*
    This function will dislpay confirmation window on page refresh during the wizard process
  */
  pageRefreshConfirm() {
    this.window.onbeforeunload = () => {
      if (this.currentStep !== undefined) {
        // eslint-disable-next-line
        return window.confirm('Confirm refresh');
      }

      return true;
    };
  }

  /*
    This function will diable fields of hidden section in order not to pick them on submit
  */
  conditionalSections() {
    if (this.conditionals.length) {
      $.each(this.conditionals, (i, el) => {
        const self = $(el);
        const fields = self.find('input, select, textarea');

        if (fields.length) {
          fields.attr('disabled', true);
        }
      });
    }
  }

  /*
    This function will manage conditional fields visibility (mortgage and other debts)
  */
  conditionalFormFields() {
    if (this.conditionalFields.length) {
      $.each(this.conditionalFields, (i, el) => {
        const fields = $(el);
        let trigger = fields
          .find('.js-form-conditional-fields-trigger')
          .first();
        trigger = trigger.add(
          trigger.siblings('.js-form-conditional-fields-trigger'),
        );
        const triggerElement = trigger.find('input[type="radio"], select');
        // const fieldsList = fields.find('.js-form-conditional-fields-list');
        const fieldsList = trigger.siblings('.js-form-conditional-fields-list');

        const triggerElementsInitial = trigger.find(
          'input[type="radio"]:checked, select',
        );

        if (triggerElementsInitial.length) {
          $.each(triggerElementsInitial, (index, elem) => {
            const te = $(elem);
            const teList = fields
              .find(
                `.js-form-conditional-fields-list[data-show-if="${te.val()}"]`,
              )
              .first();

            if (teList.length) {
              teList.show();
            } else {
              fieldsList.hide();
            }
          });
        } else {
          fieldsList.hide();
        }

        triggerElement.on('change', e => {
          let values = [e.target.value];
          fieldsList.hide();

          if (
            !this.ifCompany(fields, 'trigger') ||
            !this.ifCompany(fields, 'trigger-not')
          ) {
            return;
          }

          if (trigger.length > 1) {
            const triggerElemes = trigger.find(
              'input[type="radio"]:checked, select',
            );

            if (triggerElemes.length) {
              values = triggerElemes
                .map((index, triggerElem) => $(triggerElem).val())
                .get();
            }
          }

          let list = values.map(value =>
            fields
              .find(`.js-form-conditional-fields-list[data-show-if="${value}"]`)
              .first(),
          );

          list = list.filter(item => item.length);

          const showIfNot = fields
            .find(`.js-form-conditional-fields-list[data-show-if-not]`)
            .first();

          if (showIfNot.length) {
            const showIfNotValue = showIfNot.attr('data-show-if-not');

            if (!values.includes(showIfNotValue)) {
              list.push(showIfNot);
            }
          }

          if (list.length) {
            $.each(list, (l, item) => {
              const listItem = $(item);

              if (listItem.length) {
                listItem.show();
              }
            });
          } else {
            fieldsList.hide();
          }
        });
      });
    }
  }

  ifCompany(el, condition = 'show') {
    let attr = 'data-show-if-company';
    let isNot = false;

    if (condition === 'trigger') {
      attr = 'data-trigger-if-company';
    } else if (condition === 'trigger-not') {
      attr = 'data-trigger-if-not-company';
      isNot = true;
    }

    if (condition === 'show-not') {
      attr = 'data-show-if-not-company';
      isNot = true;
    }

    const companiesAttr = $(el).attr(attr);

    if (typeof companiesAttr === 'undefined') {
      return true;
    }

    const companies = companiesAttr.split(',');

    return isNot
      ? !companies.includes(this.offerCompanyCode)
      : companies.includes(this.offerCompanyCode);
  }

  /*
    This function will manage dynamic fields creation / removal (children's education)
  */
  manageDynamicFormFields() {
    if (!this.dynamicFormFields.length) {
      return;
    }

    const fieldsList = this.dynamicFormFields.find(
      '.js-form-dynamic-section-fields-list',
    );
    const trigger = this.dynamicFormFields.find(
      '.js-form-dynamic-section-trigger',
    );
    const defaultFields = this.dynamicFormFields.find(
      '.js-form-dynamic-section-fields',
    );
    let newFields = [];

    trigger.find('input').on('input', e => {
      newFields = [];
      fieldsList.html('');
      let { value } = e.target;

      if (value > 10) {
        value = 10;
        e.target.value = value;
      }

      if (value > 1) {
        for (let i = 1; i < value; i += 1) {
          // const field = defaultFields.clone();
          newFields.push(
            defaultFields
              .find('div')
              .first()
              .clone(),
          );
        }
      }

      if (newFields.length) {
        $.each(newFields, (i, el) => {
          const field = $(el);
          const label = field.find('label');
          const input = field.find('input');

          label.each((index, elem) => {
            const self = $(elem);
            self.attr('for', `${self.attr('for')}-${i + 2}`);
            self.text(`${self.text()} - ${i + 2}`);
          });
          input.each((index, elem) => {
            const self = $(elem);
            self.attr('name', `${self.attr('name')}-${i + 2}`);
            self.attr('id', `${self.attr('id')}-${i + 2}`);
            self.attr('placeholder', `${self.attr('placeholder')} - ${i + 2}`);
          });
          fieldsList.append(field);
        });
      }
    });
  }

  formatNumber(number, maxDigits = 2, minDigits = 0) {
    const formattedValue = new Intl.NumberFormat(
      this.locale.replace('_', '-'),
      {
        maximumFractionDigits: maxDigits,
        minimumFractionDigits: minDigits,
      },
    ).format(number);
    return `${this.currency}${formattedValue}`;
  }

  /*
    This function will format numeric fields and show labels on input
  */
  formatFormFields() {
    const forms = this.form.add(this.qtnForm).add(this.partnerForm);
    const fields = forms.find('input, select, textarea');

    forms.on('input', 'input, select, textarea', e => {
      const field = $(e.target);
      const label = field.parent().find('label.is-focus-visible');
      let { value } = e.currentTarget;

      if (field.hasClass('is-numeric')) {
        value = e.target.value.replace(/[^0-9]/g, '');
        let formattedValue = '';

        if (value.trim() !== '') {
          formattedValue = new Intl.NumberFormat().format(value);

          field.val(`${this.currency}${formattedValue}`);
        }
      }

      if (label.length) {
        if (value.trim() !== '') {
          label.addClass('is-visible');
        } else {
          label.removeClass('is-visible');
        }
      }
    });

    if (fields.length) {
      $.each(fields, (i, el) => {
        const field = $(el);

        if (
          (field.attr('type') === 'text' ||
            field.attr('type') === 'number' ||
            field[0].nodeName === 'SELECT') &&
          field.val() !== ''
        ) {
          field.trigger('input');
        }
      });
    }

    forms.on('input', 'input[type="number"]', e => {
      const field = $(e.currentTarget);
      const maxNumber = parseInt(field.attr('max'), 10);
      const minNumber = parseInt(field.attr('min'), 10);
      const nVal = field.val();
      const maxNumberLenght = `${maxNumber}`.length;
      const minNumberLenght = `${minNumber}`.length;
      const nValLenght = `${nVal}`.length;

      if (typeof maxNumber !== 'undefined' && nVal > maxNumber) {
        if (nValLenght >= maxNumberLenght) {
          field.val(maxNumber);
        }
      }

      if (typeof minNumber !== 'undefined' && nVal < minNumber) {
        if (nValLenght >= minNumberLenght) {
          field.val(minNumber);
        }
      }
    });
  }

  /*
    This function will manage form repeater fields (questionnaire beneficiaries)
  */
  manageRepeaterFormFields() {
    if (!this.repeaterFormFields.length) {
      return;
    }

    $.each(this.repeaterFormFields, (index, element) => {
      const repeaterField = $(element);

      const addRowBtn = repeaterField.find('.js-form-repeater-add');
      const fieldsNames = [];

      addRowBtn.on('click', e => {
        const addBtn = $(e.currentTarget);
        const repeater = addBtn.closest('.js-form-repeater');
        const firstRow = repeater.find('.js-form-repeater-row').first();
        const lastRow = repeater.find('.js-form-repeater-row').last();
        const maxRows = parseInt(repeater.data('max-rows'), 10) || 10;

        const firstRowFields = firstRow.find('input, select');

        if (firstRowFields.length) {
          $.each(firstRowFields, (i, el) => {
            const field = $(el);

            fieldsNames.push(field.attr('name'));
          });
        }

        if (!fieldsNames.length) {
          addBtn.hide();
          return;
        }

        let select2elems = repeater.find('.js-select2');

        if (select2elems.length) {
          repeater.find('.js-select2').select2('destroy');
        }

        const newRow = firstRow.clone();

        newRow.insertAfter(lastRow);
        const newRowFields = newRow.find('.c-form__control');
        const newRowFieldsAffix = newRow.index() + 1;

        newRow.append(
          `<button type="button" class="js-form-repeater-row-close c-form-repeater__row-close">${
            this.closeIcon
          }</button>`,
        );

        if (newRowFields.length) {
          $.each(newRowFields, (i, el) => {
            const field = $(el);
            const input = field.find('input, select');

            input.each((ind, elem) => {
              const self = $(elem);
              self.attr('name', `${fieldsNames[i]}-${newRowFieldsAffix}`);
              self.attr('id', `${fieldsNames[i]}-${newRowFieldsAffix}`);
            });
          });
        }

        select2elems = repeater.find('.js-select2');

        if (select2elems) {
          $.each(select2elems, (i, el) => {
            const selectField = $(el);
            const allowSearch = selectField.data('allow-search') || 'no';
            const showClear = selectField.data('allow-clear') || 'yes';

            const params = {
              placeholder: selectField.data('placeholder'),
              allowClear: showClear === 'yes',
              closeOnSelect: true,
            };

            if (allowSearch === 'no') {
              params.minimumResultsForSearch = -1;
            }

            selectField.select2(params);
          });
        }

        const currentRowsCount = repeater.find('.js-form-repeater-row').length;
        addBtn.toggle(currentRowsCount < maxRows);
      });

      repeaterField.on('click', '.js-form-repeater-row-close', e => {
        const closeBtn = $(e.currentTarget);
        const row = closeBtn.parent();
        const repeater = closeBtn.closest('.js-form-repeater');

        row.remove();

        const rows = repeater.find('.js-form-repeater-row');

        if (rows.length > 1) {
          for (let i = 1; i < rows.length; i += 1) {
            const newRow = $(rows[i]);

            const newRowFields = newRow.find('.c-form__control');
            const newRowFieldsAffix = newRow.index() + 1;

            if (newRowFields.length) {
              $.each(newRowFields, (ind, el) => {
                const field = $(el);
                const input = field.find('input, select');

                input.each((j, elem) => {
                  const self = $(elem);
                  self.attr('name', `${fieldsNames[ind]}-${newRowFieldsAffix}`);
                  self.attr('id', `${fieldsNames[ind]}-${newRowFieldsAffix}`);
                });
              });
            }
          }
        }
      });
    });
  }

  dateField() {
    this.dobField = $('.js-date');

    if (this.dobField.length) {
      this.dobField.on('keyup', e => {
        const self = $(e.currentTarget);
        if (e.which !== 8) {
          const input = self.val();
          let out = input.replace(/\D/g, '');
          const len = out.length;

          // if (len > 3 && len < 6) {
          //   out = `${out.substring(0, 4)}/${out.substring(4, 6)}`;
          // } else if (len >= 6) {
          //   out = `${out.substring(0, 4)}/${out.substring(
          //     4,
          //     6,
          //   )}/${out.substring(6, len)}`;
          //   out = out.substring(0, 10);
          // }

          if (len > 1 && len < 4) {
            out = `${out.substring(0, 2)}/${out.substring(2, 3)}`;
          } else if (len >= 4) {
            out = `${out.substring(0, 2)}/${out.substring(
              2,
              4,
            )}/${out.substring(4, len)}`;
            out = out.substring(0, 10);
          }
          self.val(out);
        }
      });
    }
  }

  /*
    This function will create datepicker
  */
  datePicker() {
    if (this.flatpickrElement.length) {
      $.each(this.flatpickrElement, (i, el) => {
        const flatpickrElement = $(el);
        let maxDate = new Date().setDate(new Date().getDate() - 1);
        // let defaultDate = new Date().setFullYear(new Date().getFullYear() - 18);
        let defaultDate = 'today';
        let minDate = null;
        let mode = 'single';
        const enableTime = flatpickrElement.data('f-enable-time') === 'yes';

        if (typeof flatpickrElement.data('f-max-date') !== 'undefined') {
          const n = parseFloat(flatpickrElement.attr('data-f-max-date'));
          maxDate = new Date().setDate(new Date().getDate() + n);
        }

        if (typeof flatpickrElement.data('f-def-date') !== 'undefined') {
          defaultDate = flatpickrElement.data('f-def-date');
        }

        if (typeof flatpickrElement.data('f-min-date') !== 'undefined') {
          minDate = flatpickrElement.data('f-min-date');
        }

        if (typeof flatpickrElement.data('f-mode') !== 'undefined') {
          mode = flatpickrElement.data('f-mode');
        }

        flatpickrElement.flatpickr({
          dateFormat: enableTime ? this.dateTimeFormat : this.dateFormat,
          locale: {
            firstDayOfWeek: this.firstDayOfWeek,
          },
          mode,
          maxDate,
          minDate,
          enableTime,
          defaultDate,
          disableMobile: true,
        });

        flatpickrElement.val('');
      });
    }
  }

  /*
    This function will process first, fifth and the last step box links click events
  */
  go2step2or6orFinish() {
    this.stepButton.on('click', e => {
      e.preventDefault();

      if (this.submitting) {
        return;
      }

      const button = $(e.currentTarget);
      const type = button.data('wizard-type');
      const nextStep = button.data('wizard-next-step');
      const sendQtnLink = button.data('send-qtn-link');

      this.sendQtnLink = sendQtnLink;

      if (nextStep === 'finish') {
        if (this.quoteResumeId > 0) {
          this.resumeQuoteUsed = 'yes';
        }

        this.wizardApplyType = type;

        if (type === 'submit-email') {
          this.showLoader(this.loaderTips.email);
          this.getCurrentStep();
          this.setNextStep('2b');
          this.quoteProgress = this.quoteProgressLabels.submitEmail;

          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');

            // this.postToInfusionsoft()
            //   .done(result => {
            //     if (result.ok) {
            //       this.sendEmail();
            //     } else {
            //       this.displayGeneraError();
            //     }
            //   })
            //   .fail(() => {
            //     this.displayGeneraError();
            //   });
            this.postToInfusionsoft({
              progress: 'applied-for-offer',
              customFields: {
                resume_quote_url: 'none',
              },
            })
              .done(result => {
                if (result.ok) {
                  this.sendEmail();
                } else {
                  this.displayGeneraError();
                }
              })
              .fail(() => {
                this.displayGeneraError();
              });
          });
        } else if (type === 'sign-online') {
          if (this.qtnHasDocusign) {
            this.showLoader(this.loaderTips.docusign);
            this.prepareDataForDocusign();

            this.postToInfusionsoft({
              progress: 'applied-for-offer',
              customFields: {
                resume_quote_url: 'none',
              },
            })
              .done(result => {
                if (result.ok) {
                  this.redirectToDocusign();
                } else {
                  this.displayGeneraError();
                }
              })
              .fail(() => {
                this.displayGeneraError();
              });
          }
        }
      } else {
        this.getCurrentStep();
        this.setNextStep(nextStep);

        this.conditionalElements = this.steps.find(
          `.is-conditional[data-wizard-condition-type="${type}"]`,
        );

        if (this.nextStep.length) {
          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');
          });

          if (nextStep === 2) {
            this.showLoader('');
            this.wizardType = type;
            this.go2step2();
            this.setStepBack(1);
            // this.setStepHistory(2);
            this.stepBackButton.show();
          } else if (nextStep === 6) {
            this.wizardApplyType = type;
            this.go2step6();
          }
        }
      }

      this.submitting = true;
    });

    if (this.isContactQuote || this.isInstantQuote || this.isCalculateQuote) {
      const buttonType = this.isCalculateQuote ? 'learning' : 'expert';
      const quoteButton = $(
        `.js-wizard-button[data-wizard-type="${buttonType}"]`,
      );

      if (quoteButton.length) {
        quoteButton.trigger('click');
      }

      if (this.isInstantQuote) {
        this.stepBackButton.hide();
      }
    }
  }

  setStepHistory(stepNumber) {
    this.window.history.pushState(
      { wizardStep: stepNumber },
      null,
      `#step${stepNumber}`,
    );
  }

  redirectToDocusign() {
    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_generate_docusign_link',
        security: this.formSecurityNonce,
        data: this.docusignData,
        document_id: this.docusignDocumentId,
        rm_qr_id: this.quoteResume.rowId,
      },
      response => {
        if (response.ok) {
          this.removeFromSessionStorage('qrRid');
          const docusignUrl = response.url;
          this.quoteProgress = this.quoteProgressLabels.submitSign;

          // this.postToInfusionsoft()
          //   .done(result => {
          //     if (result.ok) {
          //       this.window.onbeforeunload = null;
          //       window.location.replace(docusignUrl);
          //       // this.submitting = false;
          //     } else {
          //       this.displayGeneraError();
          //     }
          //   })
          //   .fail(() => {
          //     this.displayGeneraError();
          //   });
          this.window.onbeforeunload = null;
          window.location.replace(docusignUrl);
        } else {
          this.displayGeneraError();
        }
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });
  }

  prepareDataForDocusign() {
    const { dob, email, sex, smoker, province, rates } = this.emailData;
    const { premium, product } = this.offerAppliedFor;

    this.docusignData = {
      fields: {
        dob,
        email,
        sex,
        smoker,
        province,
        'first-name': this.emailData.first_name,
        'last-name': this.emailData.last_name,
        'coverage-amount': this.emailData.coverage_amount,
        'policy-length': this.emailData.policy_length,
        rates,
        premium,
        product,
      },
      'primary-beneficiaries': [],
      'secondary-beneficiaries': [],
    };

    $.each(this.qtnFormFields, (name, value) => {
      const key = name.replace(/^qtn-/, '');

      if (key.match(/^bene-primary/)) {
        const beneKey = key.replace(
          /^(bene-primary-)([a-z]+)(-[a-z]+)?(-[0-9]+)?/,
          '$2$3',
        );
        const beneIndexes = key.match(/^\D+([0-9]+)?/);
        const beneIndex =
          typeof beneIndexes[1] === 'undefined' ? 0 : beneIndexes[1] - 1;

        if (
          typeof this.docusignData['primary-beneficiaries'][beneIndex] ===
          'undefined'
        ) {
          this.docusignData['primary-beneficiaries'][beneIndex] = {};
        }
        this.docusignData['primary-beneficiaries'][beneIndex][beneKey] = value;
      } else if (key.match(/^bene-secondary/)) {
        const beneKey = key.replace(
          /^(bene-secondary-)([a-z]+)(-[a-z]+)?(-[0-9]+)?/,
          '$2$3',
        );
        const beneIndexes = key.match(/^\D+([0-9]+)?/);
        const beneIndex =
          typeof beneIndexes[1] === 'undefined' ? 0 : beneIndexes[1] - 1;

        if (
          typeof this.docusignData['secondary-beneficiaries'][beneIndex] ===
          'undefined'
        ) {
          this.docusignData['secondary-beneficiaries'][beneIndex] = {};
        }
        this.docusignData['secondary-beneficiaries'][beneIndex][
          beneKey
        ] = value;
      } else {
        this.docusignData.fields[key] =
          key === 'birth-place-province' ? this.getProviceValue(value) : value;
      }
    });
  }

  setupConditionalElements() {
    if (this.AllConditionalElements.length) {
      const fields = this.conditionalElements.find('input, select, textarea');

      if (fields.length) {
        fields.attr('disabled', true);
      }
      this.AllConditionalElements.hide();
    }

    if (this.conditionalElements.length) {
      const fields = this.conditionalElements.find('input, select, textarea');

      if (fields.length) {
        fields.removeAttr('disabled');
      }
      this.conditionalElements.show();
    }
  }

  /*
    This function will show step 2 form (either learning or expert)
  */
  go2step2() {
    setTimeout(() => {
      this.setupConditionalElements();
      this.scrollUp();

      this.nextStep.fadeIn(500, () => {
        this.hideLoader();
        this.nextStep.addClass('is-active');
        this.submitting = false;
      });
    }, 1000);

    this.go2step3();
  }

  partnerFormProcess() {
    this.partnerForm.off('submit');
    this.partnerForm.on('submit', e => {
      e.preventDefault();

      const formData = new FormData(e.target);
      const fieldsTypes = {
        numeric: [],
        date: [],
      };

      // eslint-disable-next-line
      for (const row of formData.entries()) {
        const [name, value] = row;
        const field = this.partnerForm.find(`[name="${name}"]`);

        if (field.is(':visible') || field.attr('type') === 'hidden') {
          this.partnerFormFields[name] = value;

          if (field.hasClass('js-date')) {
            fieldsTypes.date.push(name);
          }
        }
      }

      if (this.partnerForm.find('.js-wizard-field-error').length) {
        this.partnerForm
          .parent()
          .find('.js-wizard-field-error')
          .remove();
      }

      $.post(
        this.ajaxurl,
        {
          action: 'x5_wizard_form_validation',
          security: this.formSecurityNonce,
          fields: this.partnerFormFields,
          fieldsTypes,
        },
        response => {
          if (response.ok) {
            this.partnerModal.removeClass('show');

            this.partnerQuoteParams = this.quoteParams;

            this.partnerQuoteParams = {
              ...this.partnerQuoteParams,
              ...response.quoteParams,
            };

            this.offers = this.originalOffers;

            this.saveQuoteResumeData()
              .done(result => {
                if (result.ok) {
                  this.callQuotesApiPartner();
                } else {
                  this.displayGeneraError();
                }
              })
              .fail(() => {
                this.displayGeneraError();
              });
          } else if (response.error) {
            if (response.errors) {
              this.hideLoader();
              this.submitting = false;

              $.each(response.errors, (name, errorMsg) => {
                const field = this.partnerForm.find(`[name="${name}"]`);
                const error = $(
                  `<p class="c-wizard-field__error js-wizard-field-error">${errorMsg}</p>`,
                );

                field.parent().append(error);
              });
            } else {
              this.partnerModal.removeClass('show');
              this.displayGeneraError();
            }
          }
        },
      ).fail((xhr, status, error) => {
        // eslint-disable-next-line no-console
        console.log(error);
        this.displayGeneraError();
        this.partnerModal.removeClass('show');
      });

      this.showLoader(this.loaderTips.offers);
      this.submitting = true;
    });

    this.partnerModalClose = this.partnerForm.find('.js-wizard-partner-cancel');

    if (this.partnerModalClose.length) {
      this.partnerModalClose.on('click', () => {
        this.partnerModal.removeClass('show');

        this.peopleFilter
          .find('input[type="radio"][value="me"]')
          .trigger('click');
      });
    }
  }

  /*
    This function will process step 2 forms and call offers request function
  */
  go2step3() {
    this.form.off('submit');
    this.form.on('submit', e => {
      e.preventDefault();

      if (this.submitting) {
        return;
      }

      const errors = this.form.find('.js-wizard-field-error');

      if (errors.length) {
        errors.remove();
      }

      this.formData = new FormData(e.target);
      this.formFields = {};
      this.formFieldsTypes = {
        numeric: [],
        date: [],
      };

      // eslint-disable-next-line
      for (const row of this.formData.entries()) {
        const [name, value] = row;
        const field = this.form.find(`[name="${name}"]`);

        if (field.is(':visible') || field.attr('type') === 'hidden') {
          this.formFields[name] = value;

          if (field.hasClass('js-date')) {
            this.formFieldsTypes.date.push(name);
          }
          if (field.hasClass('is-numeric')) {
            this.formFieldsTypes.numeric.push(name);
          }
          if (field.hasClass('is-optional')) {
            this.formFieldsOptional.push(name);
          }
        }
      }

      // Add empty radios for validation
      const radios = $(e.target).find('input[type="radio"]');
      if (radios.length) {
        $.each(radios, (r, el) => {
          const radio = $(el);
          const radioName = radio.attr('name');

          if (
            typeof this.formFields[radioName] === 'undefined' &&
            !radio.is(':disabled') &&
            radio.is(':visible')
          ) {
            this.formFields[radioName] = '';
          }
        });
      }

      if (this.hasQuoteBlock) {
        this.submitting = true;
        this.processQuoteBlock();
      } else {
        this.formFields['wizard-mode'] = 2;
        this.requestOffers();
        this.stepBackButton.show();
      }
    });
  }

  /*
    This function will validate step2 forms, post data to Infusionsoft and either call quotes api or send an email with form data (when short quote contact only is used)
  */
  requestOffers() {
    if (this.submitting) {
      return;
    }

    this.originalOffers = [];

    if (this.isContactQuote) {
      this.showLoader(this.loaderTips.email);

      if (this.isCriticalIllnessQuote) {
        this.shortQuoteType = 'critical-illness';
      } else if (this.isNoMedicalQuote) {
        this.shortQuoteType = 'no-medical';
      }
    } else if (
      this.wizardType === 'learning' &&
      this.formSubmitBtn.hasClass('has-recs')
    ) {
      this.showLoader(this.loaderTips.calc);
    } else {
      this.showLoader(this.loaderTips.offers);
    }
    this.offersContainer.html('');
    this.helpBar.removeClass('is-visible').css({ 'transition-delay': '' });

    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_form_validation',
        security: this.formSecurityNonce,
        fields: this.formFields,
        fieldsTypes: this.formFieldsTypes,
        fieldsOptional: this.formFieldsOptional,
      },
      response => {
        if (response.ok) {
          this.getCurrentStep();

          if (this.isContactQuote) {
            this.quoteProgress = this.quoteProgressLabels.shortQuote;
            this.setNextStep('2b');
          } else {
            this.setNextStep(3);
          }

          this.quoteParams = response.quoteParams;

          if (this.wizardType === 'learning') {
            this.wizardSetRecommendations(response.recommended);
            if (this.formSubmitBtn.hasClass('has-recs')) {
              this.postToInfusionsoft({
                progress: `step2-${this.wizardType}`,
              })
                .done(result => {
                  if (result.ok) {
                    this.formShowRecommendations();
                  } else {
                    this.displayGeneraError();
                  }
                })
                .fail(() => {
                  this.displayGeneraError();
                });
              return;
            }
          }

          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');
            this.scrollUp();

            if (this.wizardType === 'learning') {
              this.setStepBack(2);
              this.callQuotesApi();
            } else if (this.isContactQuote) {
              if (this.shortQuoteType !== null) {
                this.postToInfusionsoft({
                  progress: this.shortQuoteType,
                })
                  .done(result => {
                    if (result.ok) {
                      this.sendEmail();
                    } else {
                      this.displayGeneraError();
                    }
                  })
                  .fail(() => {
                    this.displayGeneraError();
                  });
              } else {
                this.sendEmail();
              }
            } else {
              this.saveQuoteResumeData()
                .done(result => {
                  if (result.ok) {
                    this.postToInfusionsoft({
                      progress: this.isCriticalIllnessQuote
                        ? 'critical-illness'
                        : `step2-${this.wizardType}`,
                    })
                      .done(res => {
                        if (res.ok) {
                          this.setStepBack(2);
                          this.callQuotesApi();
                        } else {
                          this.displayGeneraError();
                        }
                      })
                      .fail(() => {
                        this.displayGeneraError();
                      });
                  } else {
                    this.displayGeneraError();
                  }
                })
                .fail(() => {
                  this.displayGeneraError();
                });
            }
          });
        } else if (response.error) {
          if (response.errors) {
            this.hideLoader();
            this.submitting = false;

            $.each(response.errors, (name, errorMsg) => {
              const field = this.form.find(`[name="${name}"]`);
              const error = $(
                `<p class="c-wizard-field__error js-wizard-field-error">${errorMsg}</p>`,
              );

              if (field.length) {
                if (field.closest('.c-form__control--radio').length) {
                  error
                    .addClass('is-top-error')
                    .insertBefore(field.closest('.c-form__control--radio'));
                } else {
                  field.parent().append(error);
                }
              }
            });

            $('body, html')
              .stop()
              .animate(
                {
                  scrollTop:
                    this.form
                      .find('.js-wizard-field-error')
                      .first()
                      .offset().top - 150,
                },
                500,
              );
          } else {
            this.displayGeneraError();
          }
        }
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });

    this.submitting = true;
  }

  formShowRecommendations() {
    this.formRecommendations.fadeIn();
    this.hideLoader();

    this.submitting = false;
    const total = this.formatNumber(this.quoteParams.faceAmount, 0);

    let html = '';
    $.each(this.recommendedData, (key, val) => {
      const label =
        typeof this.recsLabels[key] !== 'undefined' ? this.recsLabels[key] : '';

      html += `<div class="c-wizard-form__recs-row o-layout">
        <div class="c-wizard-form__recs-col o-layout__item o-layout__item--6">
          ${label}
        </div>
        <div class="c-wizard-form__recs-col o-layout__item o-layout__item--6 u-text-right">
          ${this.formatNumber(val, 0)}
        </div>
      </div>`;
    });

    html += `<div class="c-wizard-form__recs-row c-wizard-form__recs-row--total o-layout">
      <div class="c-wizard-form__recs-col o-layout__item o-layout__item--6">
        ${this.recsLabels.total}
      </div>
      <div class="c-wizard-form__recs-col o-layout__item o-layout__item--6 u-text-right">
        ${total}
      </div>
    </div>`;

    this.formRecs.html(html);
    this.formRecValue.text(total);
    this.formSubmitBtn.removeClass('has-recs').text(this.recsLabels.compare);

    this.formRecsBtn.text(this.recsLabels.moreDetails).on('click', () => {
      this.formRecs.slideToggle().toggleClass('is-open');
      this.formRecsBtn.text(
        this.formRecs.hasClass('is-open')
          ? this.recsLabels.lessDetails
          : this.recsLabels.moreDetails,
      );

      if (this.formRecsAssumptionsBtn.length) {
        this.formRecsAssumptionsBtn.fadeToggle(
          this.formRecs.hasClass('is-open'),
        );
      }
    });

    if (this.formRecsAssumptions.length) {
      this.formRecsAssumptionsBtn.on('click', () => {
        this.formRecsAssumptions.addClass('is-open');
      });
    }

    if (this.formRecsAssumptionsClose.length) {
      this.formRecsAssumptionsClose.on('click', () => {
        this.formRecsAssumptions.removeClass('is-open');
      });
    }

    $('body, html')
      .stop()
      .animate(
        {
          scrollTop: this.formRecommendations.offset().top - 150,
        },
        500,
      );

    this.form
      .find('.is-recs-calc')
      .find('input')
      .on('input', () => {
        if (this.formRecommendations.is(':visible')) {
          this.formRecommendations.fadeOut();
          this.formSubmitBtn
            .addClass('has-recs')
            .text(this.recsLabels.calculate);
        }
      });
  }

  callQuotesApiPartner() {
    if (this.isCriticalIllnessQuote) {
      this.partnerQuoteParams.NewCategory = this.partnerQuoteParams.category;
      this.partnerQuoteParams.CompLife = 'COMPLIFECI/';
    }

    $.ajax({
      url: this.quoteApiUrl,
      type: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(this.partnerQuoteParams),
      success: offers => {
        this.partnerOffers = Wizard.prepareOffers(offers);
        this.hideLoader();
        this.renderJoinedOffersList();
        this.submitting = false;
      },
      error: res => {
        // eslint-disable-next-line no-console
        console.log('error api', res);
        this.displayGeneraError();
      },
    });
  }

  /*
    This function call quotes API and call offers list render function
  */
  callQuotesApi(partner = false) {
    this.offersFilters();

    this.nextStep.fadeIn(500, () => {
      this.nextStep.addClass('is-active');
    });

    if (this.isCriticalIllnessQuote) {
      this.quoteParams.NewCategory = this.quoteParams.category;
      this.quoteParams.CompLife = 'COMPLIFECI/';
    }

    $.ajax({
      url: this.quoteApiUrl,
      type: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(this.quoteParams),
      success: offers => {
        this.offers = Wizard.prepareOffers(offers);
        if (!this.originalOffers.length) {
          this.originalOffers = this.offers;
        }

        if (partner) {
          this.partnerForm.trigger('submit');
        } else {
          if (this.partnerOffers.length) {
            this.renderJoinedOffersList();
          } else {
            this.renderOffersList();
          }
          this.hideLoader();
        }

        this.submitting = false;
      },
      error: response => {
        // eslint-disable-next-line no-console
        console.log('error api', response);
        this.displayGeneraError();
      },
    });
  }

  /*
    This function will post data to Infusionsoft and create a contact card
  */
  postToInfusionsoft(customData = {}) {
    const deferred = $.Deferred();

    if (this.infusionsoftEnable !== 'no') {
      this.prepareDataForInfusionsoft();

      if (customData) {
        this.infusionsoftData = $.extend(
          true,
          this.infusionsoftData,
          customData,
        );
      }

      const progress = this.infusionsoftData.progress || '';

      if (typeof this.infusionsoftData.progress !== 'undefined') {
        delete this.infusionsoftData.progress;
      }

      $.post(
        this.ajaxurl,
        {
          action: 'x5_wizard_infusionsoft',
          security: this.formSecurityNonce,
          data: this.infusionsoftData,
          contact_id: this.infusionsoftContactId,
          lead_source_id: this.infusionsoftLeadSourceId,
          leadSource: {
            name: this.formFields.inf_field_LeadSourceName,
          },
          progress,
        },
        response => {
          this.infusionsoftContactId = response.contactId;
          this.infusionsoftLeadSourceId = response.leadSourceId;
          deferred.resolve({ ok: true, res: response });
        },
      ).fail((xhr, status, error) => {
        this.displayGeneraError();
        deferred.reject(error);
      });
    } else {
      const { progress } = customData;
      this.prepareDataForEmail();

      if (progress === 'step2-expert' || progress === 'step2-learning') {
        $.post(
          this.ajaxurl,
          {
            action: 'x5_wizard_send_email_notification',
            security: this.formSecurityNonce,
            data: {
              ...this.emailData,
              quoteType: progress.replace('step2-', ''),
            },
          },
          response => {
            if (response.ok) {
              deferred.resolve({ ok: true });
            } else {
              this.displayGeneraError();
            }
          },
        ).fail((xhr, status, error) => {
          // eslint-disable-next-line no-console
          console.log(error);
          this.displayGeneraError();
        });
      } else {
        deferred.resolve({ ok: true });
      }
    }

    return deferred;
  }

  /*
    This function will post data to Infusionsoft and create a contact card
  */
  saveQuoteResumeData(resumeAt = 'offers') {
    const deferred = $.Deferred();

    if (this.wizard.data('resume') === 'yes') {
      deferred.resolve({ ok: true });
      return deferred;
    }

    this.quoteResume.data = {
      row_id: this.quoteResume.rowId,
      insurance_type: {
        name: this.insuranceType,
        slug: this.insuranceTypeSlug,
        target: this.insuranceTarget,
        ci: this.isCriticalIllnessQuote,
      },
      form_fields: this.formFields,
      quote_data: this.quoteParams,
      partner_form_fields: this.partnerFormFields,
      partner_quote_data: this.partnerQuoteParams,
      email_data: this.emailData,
      offer_applied_for: this.offerAppliedFor,
      qtn_data: this.qtnFormFields,
      resume_at: resumeAt,
    };

    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_save_quote_resume_data',
        security: this.formSecurityNonce,
        data: this.quoteResume.data,
      },
      response => {
        this.setSessionStorage('qrRid', response.rowId);
        this.quoteResume.rowId = response.rowId;
        this.quoteResume.link = response.link;
        deferred.resolve({ ok: true, res: response });
      },
    ).fail((xhr, status, error) => {
      this.displayGeneraError();
      deferred.reject(error);
    });

    return deferred;
  }

  /*
    This function will send an email and show the thank you page
  */
  sendEmail() {
    this.prepareDataForEmail();
    this.stepBackButton.hide();

    if (this.isPartnerSite) {
      $.post(
        this.ajaxurl,
        {
          action: 'x5_wizard_save_app_data',
          security: this.formSecurityNonce,
          email_data: this.emailData,
          insurance_type: this.insuranceType,
          offer_applied_for: this.offerAppliedFor,
          apply_type: this.wizardApplyType,
          summary_fields: this.qtnFormFields,
          summary_data: this.qtnFormFieldsForSummary,
          send_qtn_link: this.sendQtnLink,
          qtn_link_used: this.resumeQuoteUsed,
          row_id: this.quoteResumeId,
        },
        response => {
          this.sendEmailMessage(response.rowId);
        },
      ).fail((xhr, status, error) => {
        this.displayGeneraError();
        // eslint-disable-next-line no-console
        console.log(error);
      });
    } else {
      this.sendEmailMessage();
    }

    this.submitting = true;
  }

  sendEmailMessage(rowId = 0) {
    const questinnaireFields = { ...this.qtnFormFieldsForSummary };

    $.each(questinnaireFields, (i, el) => {
      const fieldName = Object.keys(el)[0];

      if (fieldName.match(/(qtn-partner-.+)/)) {
        delete questinnaireFields[i];
      }
    });

    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_send_email',
        security: this.formSecurityNonce,
        data: this.emailData,
        wizard_type: this.wizardType,
        offer: this.offerAppliedFor,
        questionnaire: questinnaireFields,
        send_qtn_link: this.sendQtnLink,
        row_id: rowId,
        rm_qr_id: this.quoteResume.rowId,
      },
      response => {
        if (response.ok) {
          this.displayQuoteThankYou();
          this.removeFromSessionStorage('qrRid');
        } else {
          this.displayGeneraError();
        }
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });
  }

  /*
    This function will render offers list with data received from quotes API
  */
  renderOffersList() {
    let html = '';

    // for agent sites only - start
    if (typeof this.formFields['wizard-insurance-company'] !== 'undefined') {
      this.offers = this.offers.filter(
        offer =>
          offer.companyCode === this.formFields['wizard-insurance-company'],
      );
    }
    // for agent sites only - end

    if (this.offers.length) {
      const offersOnTop = this.offers.filter(offer =>
        this.companiesOnTop.includes(offer.companyCode),
      );

      if (offersOnTop.length) {
        const offersNotOnTop = this.offers.filter(
          offer => !this.companiesOnTop.includes(offer.companyCode),
        );

        this.offers = [...offersOnTop, ...offersNotOnTop];
      }

      this.compareAll.show();

      for (let i = 0; i < this.offers.length; i += 1) {
        const {
          premium,
          product,
          healthCategory,
          companyCode,
          company,
        } = this.offers[i];

        const companyData = this.companies[companyCode];

        if (typeof companyData !== 'undefined') {
          this.offers[i] = Object.assign(this.offers[i], companyData);
          this.offers[i].id = i;

          const premiumFormatted = this.formatPrice(premium);

          const info = [
            'financialStrength',
            'customerService',
            'founded',
            'customers',
          ];

          let infoHtml = '';
          let offerCheckbox = '';

          for (let j = 0; j < info.length; j += 1) {
            const lowerCaseClass = Wizard.camelToKebabCase(info[j]);
            const infoIcon = this.offersLabelsIcons[info[j]].icon
              ? `<span class="c-wizard-offer__info-icon"><img src="${
                  this.offersLabelsIcons[info[j]].icon
                }" alt="${this.offersLabelsIcons[info[j]].label}"/></span>`
              : '';

            if (info[j] === 'customers') {
              offerCheckbox = `
              <div class="c-wizard-offer-compare js-wizard-offer-compare has-checkbox">
                <div class="is-checkbox">
                  <input type="checkbox" id="wizard-compare-${i}" data-offer-id="${i}">
                  <span class="is-checkbox-icon"></span>
                </div>
              </div>`;
            }

            infoHtml += `<div class="o-layout__item o-layout__item--medium-3 c-wizard-offer__${lowerCaseClass}">
              <span class="c-wizard-offer__info">
                <strong>${companyData[info[j]]}</strong>
                <span class="c-wizard-offer__info-label">${
                  this.offersLabelsIcons[info[j]].label
                }</span>
                ${infoIcon}
              </span>
              ${offerCheckbox}
            </div>`;
          }

          html += `<div class="c-wizard-offer js-wizard-offer ${
            companyData.discount !== '' ? 'has-discount' : ''
          }" style="animation-delay:${0.3 * i}s">
            <div class="c-wizard-offer__top o-layout">
              <div class="o-layout__item o-layout__item--medium-3">
                <div class="c-wizard-offer__logo">${
                  companyData.logo ? companyData.logo : company
                }</div>
              </div>
              <div class="o-layout__item o-layout__item--medium-3">
                <h4 class="h6 c-wizard-offer__product"><strong>${product}</strong></h4>
              </div>
              <div class="o-layout__item o-layout__item--medium-3">
                <span class="c-wizard-offer__health-category">${healthCategory}</span>
              </div>
              <div class="o-layout__item o-layout__item--medium-3 u-hide-mobile">
                ${
                  companyData.discount !== ''
                    ? `<div class="c-wizard-offer__discount"><span>${
                        companyData.discount
                      }</span></div>`
                    : ''
                }
                <div class="h6 c-wizard-offer__premium">
                  <strong>${premiumFormatted}</strong>
                  <button type="button" class="c-wizard-offer__apply js-wizard-offer-apply c-btn c-btn--${
                    companyData.discount !== '' ? 'primary' : 'secondary'
                  }" data-offer-id="${i}">${this.offerLabels.apply}</button>
                </div>
              </div>
            </div>
            <div class="c-wizard-offer__bottom o-layout">${infoHtml}</div>
            <div class="c-wizard-offer__mobile o-layout u-show-mobile">
              <div class="o-layout__item o-layout__item--12">
                ${
                  companyData.discount !== ''
                    ? `<div class="c-wizard-offer__discount"><span>${
                        companyData.discount
                      }</span></div>`
                    : ''
                }
              </div>
              <div class="o-layout__item o-layout__item--6">
                <div class="h6 c-wizard-offer__premium">${offerCheckbox}<strong>${premiumFormatted}</strong></div>
              </div>
              <div class="o-layout__item o-layout__item--6 u-text-right">
                <button type="button" class="c-wizard-offer__apply js-wizard-offer-apply c-btn c-btn--${
                  companyData.discount !== '' ? 'primary' : 'secondary'
                }" data-offer-id="${i}">${this.offerLabels.apply}</button>
              </div>
            </div>
          </div>`;
        }
      }
    } else {
      this.compareAll.hide();

      html += `<h4 class="c-wizard-offers__not-found">${
        this.offerLabels.noOffers
      }</h4>`;
    }

    this.offersHeader.stop().animate({ opacity: 1 }, 500);
    this.offersContainer.html(html);

    if (this.offers.length > 1) {
      this.compareOffers();
    }
    this.helpBar
      .addClass('is-visible')
      .css({ 'transition-delay': `${this.offers.length * 0.3}s` });
    setTimeout(() => {
      this.scrollToOffers();
    }, 100);
  }

  renderJoinedOffersList() {
    this.joinedOffers = [];

    if (this.offers.length && this.partnerOffers.length) {
      this.offers.forEach(offer => {
        const o = { ...offer };
        const found = this.partnerOffers.find(po => {
          if (offer.product === po.product) {
            o.premium += po.premium;
          }
          return offer.product === po.product;
        });

        if (!found) {
          this.notMatchedOffers.push(offer);
        } else {
          this.joinedOffers.push(o);
        }
      });

      this.myBestPrice = this.offers.reduce(
        (min, p) => (p.premium < min ? p.premium : min),
        this.offers[0].premium,
      );

      this.partnerBestPrice = this.partnerOffers.reduce(
        (min, p) => (p.premium < min ? p.premium : min),
        this.partnerOffers[0].premium,
      );

      if (this.joinedSection.length) {
        this.joinedSectionMe = this.joinedSection.find('.js-wizard-joined-me');
        this.joinedSectionPartner = this.joinedSection.find(
          '.js-wizard-joined-partner',
        );
        this.joinedSectionMeRate = this.joinedSectionMe.find(
          '.js-wizard-joined-rate',
        );
        this.joinedSectionPartnerRate = this.joinedSectionPartner.find(
          '.js-wizard-joined-rate',
        );
        this.joinedSectionMeDob = this.joinedSectionMe.find(
          '.js-wizard-joined-dob',
        );
        this.joinedSectionPartnerDob = this.joinedSectionPartner.find(
          '.js-wizard-joined-dob',
        );

        const ratePer =
          this.partnerQuoteParams.mode === 2
            ? x5script.ratePerMonth
            : x5script.ratePerYear;
        const dobMe = new Date(
          this.quoteParams.birthYear,
          this.quoteParams.birthMonth - 1,
          this.quoteParams.birthday,
        );
        const dobPartner = new Date(
          this.partnerQuoteParams.birthYear,
          this.partnerQuoteParams.birthMonth - 1,
          this.partnerQuoteParams.birthday,
        );
        const sexMe =
          this.quoteParams.sex === 1 ? x5script.male : x5script.female;
        const sexPartner =
          this.partnerQuoteParams.sex === 1 ? x5script.male : x5script.female;
        const smokerMe = this.quoteParams.smoker
          ? x5script.smoker
          : x5script.nonSmoker;
        const smokerPartner = this.partnerQuoteParams.smoker
          ? x5script.smoker
          : x5script.nonSmoker;

        this.joinedSection.fadeIn();

        this.joinedSectionMeRate.text(
          `${this.formatPrice(this.myBestPrice)}/${ratePer}`,
        );
        this.joinedSectionPartnerRate.text(
          `${this.formatPrice(this.partnerBestPrice)}/${ratePer}`,
        );
        this.joinedSectionMeDob.text(
          `${this.formatDate(dobMe)} | ${sexMe} | ${smokerMe}`,
        );
        this.joinedSectionPartnerDob.text(
          `${this.formatDate(dobPartner)} | ${sexPartner} | ${smokerPartner}`,
        );
      }
    } else {
      this.joinedSection.fadeOut();
    }

    this.offers = this.joinedOffers;
    this.renderOffersList();
  }

  /*
    This function will initialize offers list filters
  */
  offersFilters() {
    this.coverageFilter();
    this.policyLengthFilter();
    this.modeFilter();
    this.peopleCoveredFilter();
  }

  /*
    This function will setup coverage amount slider filter
  */
  coverageFilter() {
    const filterBox = this.coverageSlider.closest('.js-wizard-filter');

    if (!this.coverageValues) {
      filterBox.hide();
    }

    const values = Object.keys(this.coverageValues);

    let selectedValue = this.quoteParams.faceAmount || values[0];

    if (this.hasQuoteBlock && values.includes('100000')) {
      selectedValue = '100000';
    }

    const valueIndex = values.indexOf(selectedValue);

    let coverageValueData = this.coverageValues[selectedValue] || {};
    const currentValueElement = filterBox.find('.js-wizard-filter-value');

    this.coverageSliderObject = this.coverageSlider.slider({
      max: values.length - 1,
      create: event => {
        const slider = $(event.target);
        const handle = slider.find('.ui-slider-handle');

        if (coverageValueData.sliderValue) {
          handle.html(`<span>${coverageValueData.sliderValue}</span>`);

          if (valueIndex !== -1) {
            slider.slider('value', valueIndex);
          }

          if (this.hasQuoteBlock) {
            const coverageDropdown = slider
              .closest('.js-wizard-form')
              .find(
                'input[name="wizard-coverage"], select[name="wizard-coverage"]',
              );

            if (coverageDropdown.length) {
              coverageDropdown.val(selectedValue);
              coverageDropdown.trigger('change');
            }
          }
        }

        if (coverageValueData.label) {
          currentValueElement.text(`${coverageValueData.label}`);
        }
      },
      change: (event, ui) => {
        clearTimeout(this.uiSliderTimeout);

        if (this.sliderLoaded) {
          const value = values[ui.value];

          this.formFields['wizard-coverage'] = value;

          if (this.hasQuoteBlock) {
            const slider = $(event.target);

            if (slider.length) {
              const coverageDropdown = slider
                .closest('.js-wizard-form')
                .find(
                  'input[name="wizard-coverage"], select[name="wizard-coverage"]',
                );

              if (coverageDropdown.length) {
                coverageDropdown.val(value);
                coverageDropdown.trigger('change');
              }
              if (typeof this.formFields['wizard-term'] === 'undefined') {
                this.formFields['wizard-term'] = '';
              }
              this.processQuoteBlock();
            }
          } else {
            this.filterOffers();
          }
        }

        this.sliderLoaded = true;
      },
      slide: (event, ui) => {
        clearTimeout(this.uiSliderTimeout);
        const value = values[ui.value];
        coverageValueData = this.coverageValues[value] || {};

        const slider = $(event.target);
        const handle = slider.find('.ui-slider-handle');

        if (coverageValueData.sliderValue) {
          handle.html(`<span>${coverageValueData.sliderValue}</span>`);
        }

        if (coverageValueData.label) {
          currentValueElement.text(`${coverageValueData.label}`);
        }

        this.uiSliderTimeout = setTimeout(() => {
          this.formFields['wizard-coverage'] = value;

          if (this.hasQuoteBlock) {
            if (slider.length) {
              const coverageDropdown = slider
                .closest('.js-wizard-form')
                .find(
                  'input[name="wizard-coverage"], select[name="wizard-coverage"]',
                );

              if (coverageDropdown.length) {
                coverageDropdown.val(value);
                coverageDropdown.trigger('change');
              }
              if (typeof this.formFields['wizard-term'] === 'undefined') {
                this.formFields['wizard-term'] = '';
              }
              this.processQuoteBlock();
            }
          } else {
            this.filterOffers();
          }
        }, 1000);
      },
    });
  }

  /*
    This function will setup policy lenght filter
  */
  policyLengthFilter() {
    const selectedValue = this.quoteParams.category;
    const filterBox = this.termFilter.closest('.js-wizard-filter');
    const currentValueElement = filterBox.find('.js-wizard-filter-value');
    let selectedOption = this.termFilter.find('option[value]').first();

    if (selectedValue !== '') {
      this.termFilter.val(selectedValue).trigger('change');
      selectedOption = this.termFilter
        .find(`option[value="${selectedValue}"]`)
        .first();
    }

    if (selectedOption.length) {
      currentValueElement.text(`${selectedOption.text()}`);
    }

    this.termFilter.on('change', e => {
      const { value } = e.target;

      this.formFields['wizard-term'] = value;

      currentValueElement.text(
        $(e.target)
          .find('option:selected')
          .text(),
      );

      this.filterOffers();
    });
  }

  /*
    This function will setup policy rates filter
  */
  modeFilter() {
    const radios = this.ratesFilter.find('input[type="radio"]');
    const selectedValue = this.quoteParams.mode || 2;
    const filterBox = this.ratesFilter.closest('.js-wizard-filter');
    const currentValueElement = filterBox.find('.js-wizard-filter-value');

    this.modeFilterChange(
      radios,
      selectedValue,
      currentValueElement,
      this.ratesFilter,
    );

    radios.on('change', e => {
      const { value } = e.target;
      this.modeFilterChange(
        radios,
        value,
        currentValueElement,
        this.ratesFilter,
      );

      this.formFields['wizard-mode'] = value;

      this.filterOffers();
    });
  }

  /*
    This function will trigger partner popup
  */
  peopleCoveredFilter() {
    const radios = this.peopleFilter.find('input[type="radio"]');
    const selectedValue = this.peopleFilter
      .find('input[type="radio"]:checked')
      .val();
    const filterBox = this.peopleFilter.closest('.js-wizard-filter');
    const currentValueElement = filterBox.find('.js-wizard-filter-value');

    this.modeFilterChange(
      radios,
      selectedValue,
      currentValueElement,
      this.peopleFilter,
    );

    radios.on('change', e => {
      const { value } = e.target;
      this.modeFilterChange(
        radios,
        value,
        currentValueElement,
        this.peopleFilter,
      );

      if (value === 'partner') {
        this.partnerModal.addClass('show');
        this.partnerFormProcess();
      } else if (value === 'me') {
        this.joinedSection.fadeOut();
        this.partnerFormFields = {};
        this.partnerOffers = [];
        this.partnerQuoteParams = [];
        this.saveQuoteResumeData();

        setTimeout(() => {
          this.offers = this.originalOffers;
          this.renderOffersList();
        }, 300);
      }
    });
  }

  /*
    This function will manage offers list filters by recalling the quotes api and updating Infusionsoft data
  */
  filterOffers() {
    if (this.submitting) {
      return;
    }

    this.originalOffers = [];

    this.showLoader(this.loaderTips.offers);
    this.offersContainer.html('');
    this.helpBar.removeClass('is-visible').css({ 'transition-delay': '' });
    this.compareAllCheckbox.removeAttr('checked');
    this.compareOffersButton.removeClass('show');

    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_form_validation',
        security: this.formSecurityNonce,
        fields: this.formFields,
        fieldsTypes: this.formFieldsTypes,
        fieldsOptional: this.formFieldsOptional,
      },
      response => {
        // this.submitting = false;

        if (response.ok) {
          this.quoteParams = response.quoteParams;

          this.postToInfusionsoft()
            .done(result => {
              if (result.ok) {
                if (Object.keys(this.partnerFormFields).length) {
                  this.callQuotesApi(true);
                } else {
                  this.callQuotesApi();
                }
              } else {
                this.displayGeneraError();
              }
            })
            .fail(() => {
              this.displayGeneraError();
            });
        } else {
          this.displayGeneraError();
        }
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });

    this.submitting = true;
  }

  /*
    This function will manage offers comparison checkboxes and buttons and call comparison render function
  */
  compareOffers() {
    const offersCheckboxes = this.offersContainer.find(
      '.js-wizard-offer-compare input[type="checkbox"]',
    );

    offersCheckboxes.on('change', () => {
      this.toggleCompareButton();
    });

    this.compareAllCheckbox.on('change', e => {
      const self = $(e.target);

      if (offersCheckboxes.length) {
        offersCheckboxes.prop('checked', self.is(':checked'));
      }

      this.toggleCompareButton();
    });

    this.compareOffersButton.off('click');
    this.compareOffersButton.on('click', () => {
      const compareError = this.wizard.find('.js-wizard-compare-error');
      this.stepBackButton.hide();

      if (compareError.length) {
        compareError.remove();
      }

      const selectedOffers = this.offersContainer.find(
        '.js-wizard-offer-compare input[type="checkbox"]:checked:visible',
      );

      if (selectedOffers.length < 2) {
        $(
          `<span class="c-wizard-compare__error js-wizard-compare-error">${
            this.wizardCompareData.selectError
          }</span>`,
        ).insertAfter(this.compareOffersButton.parent());
      } else {
        $.each(selectedOffers, (i, el) => {
          const offer = $(el);
          const offerId = offer.data('offer-id');
          const offerData = this.offers[offerId];

          if (typeof this.offers[offerId] !== 'undefined') {
            this.offersToCompare.push(offerData);
          }
        });

        this.getCurrentStep();
        this.setNextStep(4);

        this.showLoader('');

        this.currentStep.fadeOut(300, () => {
          this.currentStep.removeClass('is-active');
          this.scrollUp();

          this.nextStep.fadeIn(500, () => {
            this.nextStep.addClass('is-active');
            this.hideLoader();

            if (typeof this.compareCarousel !== 'undefined') {
              this.compareCarousel.trigger('destroy.owl.carousel');
            }
            setTimeout(() => {
              this.renderOffersComparison();
            });
          });
        });
      }
    });

    this.compareBackButton.off('click');
    this.compareBackButton.on('click', () => {
      this.getCurrentStep();
      this.setNextStep(3);

      this.showLoader('');

      this.currentStep.fadeOut(300, () => {
        this.currentStep.removeClass('is-active');
        this.scrollUp();

        this.compareTable.css({ opacity: 0 });
        this.offersToCompare = [];

        this.nextStep.fadeIn(500, () => {
          this.nextStep.addClass('is-active');
          this.stepBackButton.show();
          this.hideLoader();
        });
      });
    });
  }

  /*
    This function will render offers comparison table and create owl carousel for the offers columns
  */
  renderOffersComparison() {
    const headers = [
      'company',
      'tariff',
      'smoker',
      'financialStrength',
      'customerService',
      'founded',
      'customers',
      'price',
    ];

    const data = [
      'logo',
      'product',
      'healthCategory',
      'financialStrength',
      'customerService',
      'founded',
      'customers',
      'premium',
    ];

    if (!this.offersToCompare.length) {
      this.showLoader('');
      this.displayGeneraError();

      return;
    }

    let headersHtml = '';
    let columnsHtml = '';

    headersHtml +=
      '<div class="c-wizard-compare-table__column js-wizard-compare-table-column">';
    for (let i = 0; i < headers.length; i += 1) {
      const lowerCaseClass = Wizard.camelToKebabCase(headers[i]);
      const icon = this.offersLabelsIcons[headers[i]].icon
        ? `<span class="c-wizard-compare-table__icon"><img src="${
            this.offersLabelsIcons[headers[i]].icon
          }" alt="${this.offersLabelsIcons[headers[i]].label}"/></span>`
        : '';

      headersHtml += `<div class="c-wizard-compare-table__row c-wizard-compare-table__row--${lowerCaseClass} js-wizard-compare-table-row">
        ${icon}
        <span class="c-wizard-compare-table__label">${
          this.offersLabelsIcons[headers[i]].label
        }</span>
      </div>`;
    }
    headersHtml += '</div>';

    if (this.offersToCompare.length) {
      $.each(this.offersToCompare, (index, offer) => {
        columnsHtml +=
          '<div class="c-wizard-compare-table__column js-wizard-compare-table-column">';

        for (let i = 0; i < data.length; i += 1) {
          const columnName = data[i];
          let columnValue = offer[columnName];
          let columnValueClass = '';

          const lowerCaseClass = Wizard.camelToKebabCase(data[i]);

          if (columnName === 'logo' && columnValue === '') {
            columnValue = offer.company;
          }

          if (columnName === 'premium' && columnValue !== '') {
            columnValue = this.formatPrice(columnValue);
          }

          if (columnName === 'premium' || columnName === 'product') {
            columnValueClass = 'h6';
          }

          columnsHtml += `<div class="c-wizard-compare-table__row c-wizard-compare-table__row--${lowerCaseClass} js-wizard-compare-table-row">
            <span class="c-wizard-compare-table__value ${columnValueClass}">${columnValue}</span>
          </div>`;
        }

        columnsHtml += `<div class="c-wizard-compare-table__row c-wizard-compare-table__row--apply js-wizard-compare-table-row">
          <button type="button" class="c-wizard-offer__apply js-wizard-offer-apply c-btn c-btn--secondary" data-offer-id="${
            offer.id
          }">${this.offerLabels.apply}</button>
        </div>`;

        columnsHtml += '</div>';
      });
    }

    this.compareTableHeaders.html(headersHtml);
    this.compareTableData.html(columnsHtml);

    this.compareTableData.on('initialized.owl.carousel', event => {
      setTimeout(() => {
        const currentIndex = event.page.index;
        this.setActiveDots(currentIndex);

        this.setCompareTableRowsHeight();

        this.compareTable.stop().animate({ opacity: 1 }, 300);
      }, 100);
    });

    const owlItems = this.compareTableData.find(
      '.js-wizard-compare-table-column',
    );

    this.compareCarousel = this.compareTableData.owlCarousel({
      dots: true,
      dotsEach: owlItems.length < 25,
      nav: false,
      navText: ['', ''],
      mouseDrag: true,
      touchDrag: true,
      navSpeed: 1000,
      dotsSpeed: 1000,
      dragEndSpeed: 1000,
      autoplay: false,
      loop: false,
      autoplaySpeed: 1000,
      autoplayTimeout: 3000,
      autoplayHoverPause: true,
      margin: 0,
      responsiveRefreshRate: 300,
      responsive: {
        0: {
          items: owlItems.length > 2 ? 2 : owlItems.length,
          // startPosition: owlItems.length > 1 ? 2 : owlItems.length - 1,
          loop: owlItems.length > 2,
        },
        768: {
          items: owlItems.length > 3 ? 3 : owlItems.length,
          // startPosition: owlItems.length > 3 ? 2 : owlItems.length - 1,
          loop: owlItems.length > 3,
        },
      },
    });

    this.compareTableData.on('resized.owl.carousel', () => {
      this.setCompareTableRowsHeight();
    });

    this.compareTableData.on('changed.owl.carousel', event => {
      const currentIndex = event.page.index;
      this.setActiveDots(currentIndex);
    });
  }

  /*
    This function will manage offers apply now event, update data in Infusionsoft and proccess to step 6 (apply choice)
  */
  applyForOffer() {
    this.offersContainer
      .add(this.compareTable)
      .on('click', '.js-wizard-offer-apply', e => {
        if (this.submitting) {
          return;
        }

        const offerApplyBtn = $(e.currentTarget);
        const offerId = offerApplyBtn.data('offer-id');
        this.offerAppliedFor = this.offers[offerId];
        this.offerCompanyCode = this.offerAppliedFor.companyCode;

        this.offerAppliedFor.premium = this.formatPrice(
          this.offerAppliedFor.premium,
        );

        if (this.isCriticalIllnessQuote || this.sendQtnLink === 'yes') {
          this.showLoader(this.loaderTips.email);
          this.getCurrentStep();
          this.setNextStep('2b');
          this.quoteProgress = this.quoteProgressLabels.submitEmail;

          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');

            this.postToInfusionsoft({
              progress: 'applied-for-offer',
            })
              .done(result => {
                if (result.ok) {
                  this.sendEmail();
                } else {
                  this.displayGeneraError();
                }
              })
              .fail(() => {
                this.displayGeneraError();
              });
          });
        } else {
          this.qtnMaxLengthFields();
          this.getCurrentStep();
          this.setNextStep(5);
          this.setStepBack(3);
          this.stepBackButton.show();
          this.offersToCompare = [];

          this.showLoader('');

          this.currentStep.fadeOut(300, () => {
            this.currentStep.removeClass('is-active');
            this.scrollUp();

            this.nextStep.fadeIn(500, () => {
              this.nextStep.addClass('is-active');
              this.hideLoader();
              this.submitting = false;
            });

            this.submitting = true;
          });
        }
      });
  }

  /*
    This function will manage step6 box links (apply online, more questions), update data in Infusionsoft and either send a quote request email or process to the questionnaire
  */
  go2step6() {
    if (this.wizardApplyType === 'apply-contact') {
      this.showLoader(this.loaderTips.email);
      this.setNextStep('2b');

      this.postToInfusionsoft({
        progress: 'applied-for-offer',
        customFields: {
          resume_quote_url: 'none',
        },
      })
        .done(result => {
          if (result.ok) {
            this.sendEmail();
          } else {
            this.displayGeneraError();
          }
        })
        .fail(() => {
          this.displayGeneraError();
        });
    } else {
      this.showLoader(this.loaderTips.qtn);
      this.quoteProgress = this.quoteProgressLabels.applyOnline;

      this.prepareDataForEmail();
      this.saveQuoteResumeData('qtn')
        .done(result => {
          if (result.ok) {
            this.startQuestionnaire(false);
          } else {
            this.displayGeneraError();
          }
        })
        .fail(() => {
          this.displayGeneraError();
        });
    }
  }

  /*
    This function display the questionnaire page and call the questionnaire steps handler function
  */
  startQuestionnaire(prepare = true) {
    if (prepare) {
      this.prepareDataForEmail();
    }

    this.qtnOfferLogo.html(this.offerAppliedFor.logo.replace(/\\"/g, '"'));
    this.qtnOffer
      .find('.js-wizard-qtn-offer-coverage strong')
      .text(this.emailData.coverage_amount);
    this.qtnOffer
      .find('.js-wizard-qtn-offer-term strong')
      .text(this.emailData.policy_length);
    this.qtnOffer
      .find('.js-wizard-qtn-offer-rates strong')
      .text(this.emailData.rates);

    this.qtnShowIfCopmany();

    if (Object.keys(this.partnerFormFields).length) {
      this.partnerFields.show();
    } else {
      this.partnerFields.hide();
    }

    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_company_has_docusign',
        security: this.formSecurityNonce,
        offer: this.offerAppliedFor,
        docType: this.isCriticalIllnessQuote ? 'ci' : 'life',
      },
      response => {
        this.qtnHasDocusign = response.hasDocusign;
        const signOnlineButton = this.wizard.find(
          '.js-wizard-button[data-wizard-type="sign-online"]',
        );

        if (!this.qtnHasDocusign) {
          if (signOnlineButton.length) {
            signOnlineButton.parent().hide();
          }
        } else {
          this.docusignDocumentId = response.documentId;

          if (signOnlineButton.length) {
            signOnlineButton.parent().show();
          }
        }

        this.nextStep.fadeIn(500, () => {
          this.hideLoader();
          this.nextStep.addClass('is-active');
          this.setStepBack(5);

          this.qtnPrefillFields();
          this.questionnaireSteps();
        });
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });
  }

  /*
    This function will handle questinnaire form and manage changing steps
  */
  questionnaireSteps() {
    this.submitting = false;
    this.setQtnSteps();

    this.qtnShowIfCopmany();

    this.qtnForm.on('submit', e => {
      e.preventDefault();

      if (this.submitting) {
        return;
      }

      const errors = this.qtnForm.find('.js-wizard-field-error');

      if (errors.length) {
        errors.remove();
      }

      this.qtnFormData = new FormData(e.target);

      // Clear beneficiary rows in case some were added and then deleted
      if (this.qtnCurrentStep.data('qtn-form-step') === 'beneficiary') {
        $.each(this.qtnFormFields, name => {
          if (name.match(/(qtn-bene-.+)/)) {
            delete this.qtnFormFields[name];
          }
        });
      }

      //  Clear active step fields array
      this.qtnFormFieldsTypes = {
        numeric: [],
        date: [],
      };
      $.each(this.qtnFormFields, name => {
        const field = this.qtnForm.find(`[name="${name}"]`);
        if (
          field.length &&
          field.closest('.js-wizard-qtn-form-step').hasClass('is-active')
        ) {
          delete this.qtnFormFields[name];
        }
      });
      $.each(this.qtnFormFieldsForSummary, (i, el) => {
        const fieldName = Object.keys(el)[0];
        const field = this.qtnForm.find(`[name="${fieldName}"]`);

        if (
          field.length &&
          field.closest('.js-wizard-qtn-form-step').hasClass('is-active')
        ) {
          delete this.qtnFormFieldsForSummary[i];
        }
      });
      // -- end Clear active step fields array

      // get new fields data
      let i = 0;
      // eslint-disable-next-line
      for (const row of this.qtnFormData.entries()) {
        const [name, value] = row;
        const field = this.qtnForm.find(`[name="${name}"]`);

        if (
          field.is(':visible') &&
          (field.closest('.js-wizard-qtn-form-step').hasClass('is-active') ||
            field.closest('.js-wizard-qtn-form-step').hasClass('is-past'))
        ) {
          const fieldElement = this.qtnForm.find(
            `.c-form__control [name="${name}"]`,
          );
          let fieldLabel = null;

          if (fieldElement.length && !fieldElement.is(':disabled')) {
            if (fieldElement.attr('type') === 'radio') {
              fieldLabel = fieldElement
                .closest('.c-form__control')
                .prev('.h6')
                .children(':visible');
            } else {
              fieldLabel = fieldElement.parent().find('label');
            }
          }
          this.qtnFormFieldsForSummary[i] = {};

          this.qtnFormFieldsForSummary[i][name] = {
            label: fieldLabel.text(),
            val:
              name === 'qtn-birth-place-province'
                ? this.getProviceValue(value)
                : value,
          };
          this.qtnFormFields[name] = value;

          if (field.hasClass('js-date')) {
            this.qtnFormFieldsTypes.date.push(name);
          }
          if (field.hasClass('is-numeric')) {
            this.qtnFormFieldsTypes.numeric.push(name);
          }
          if (field.hasClass('is-optional')) {
            this.qtnFormFieldsOptional.push(name);
          }
        }
        i += 1;
      }

      // Add empty radios for validation
      const radios = this.qtnCurrentStep.find('input[type="radio"]');
      if (radios.length) {
        $.each(radios, (r, el) => {
          const radio = $(el);
          const radioName = radio.attr('name');

          if (
            typeof this.qtnFormFields[radioName] === 'undefined' &&
            !radio.is(':disabled') &&
            radio.is(':visible')
          ) {
            this.qtnFormFields[radioName] = '';
          }
        });
      }

      if (this.qtnCurrentStep.data('qtn-form-step') !== 'summary') {
        this.qtnStepValidate();
      }

      if (this.qtnNextStep.data('qtn-form-step') === 'summary') {
        this.renderSummary();
      }
    });

    this.qtnFormBackBtn.on('click', () => {
      if (this.submitting) {
        return;
      }

      this.qtnForm.stop().animate({ opacity: 0 }, 500, () => {
        this.qtnProgressBar.removeClass('is-forward').addClass('is-backwards');
        if (this.qtnPrevStep.length) {
          this.qtnCurrentStep.removeClass('is-active is-past');
          this.qtnPrevStep.removeClass('is-past').addClass('is-active');
          this.setQtnSteps();
          this.setQtnProgressBar();
          this.qtnFormBackBtn.toggle(this.qtnPrevStep.length > 0);
          this.qtnFormBtn.toggle(this.qtnNextStep.length > 0);

          if (this.qtnCurrentStep.attr('data-qtn-form-step') === 'personal') {
            this.stepBackButton.show();
          }
        }
        this.qtnForm.stop().animate({ opacity: 1 }, 700);
      });
    });
  }

  qtnShowIfCopmany() {
    const showIfSections = this.qtnForm.find('[data-show-if-company]');
    const showIfNotSections = this.qtnForm.find('[data-show-if-not-company]');

    if (showIfSections.length) {
      $.each(showIfSections, (i, el) => {
        const section = $(el);
        const fields = section.find('input, select, textarea');

        if (!this.ifCompany(section, 'show')) {
          section.hide();

          if (fields.length) {
            fields.prop('disabled', true);
          }
        } else {
          section.show();

          if (fields.length) {
            fields.removeAttr('disabled');
          }
        }
      });
    }

    if (showIfNotSections.length) {
      $.each(showIfNotSections, (i, el) => {
        const section = $(el);
        const fields = section.find('input, select, textarea');

        if (!this.ifCompany(section, 'show-not')) {
          section.hide();

          if (fields.length) {
            fields.prop('disabled', true);
          }
        } else {
          section.show();

          if (fields.length) {
            fields.removeAttr('disabled');
          }
        }
      });
    }
  }

  getProviceValue(value) {
    let provinceValue = '';

    for (let i = 0; i < this.provinceOptions.length; i += 1) {
      if (this.provinceOptions[i].value === value) {
        provinceValue = this.provinceOptions[i].label;
      }
    }

    return provinceValue;
  }

  /*
    This function will render questinnaire summary rows for beneficiaries
  */
  renderBeneSummary(beneRows, type) {
    let html = '';
    const header =
      type === 'primary' ? this.benePrimaryHeader : this.beneSecondaryHeader;

    if (beneRows.length) {
      html += `<div class="c-wizard-qtn-summary-row o-layout"><div class="c-wizard-qtn-summary-column c-wizard-qtn-summary-column--header o-layout__item o-layout__item--medium-12"><strong>${header}</strong></div>
      <div class="c-wizard-qtn-summary-subrows o-layout__item o-layout__item--12">`;

      $.each(beneRows, (index, rows) => {
        html += `
          <div class="c-wizard-qtn-summary-subrow">
            <span class="c-wizard-qtn-summary-subrow__number">${index +
              1}.</span>
            <div class="c-wizard-qtn-summary-subrow__inner o-layout o-layout--gutless">`;

        $.each(rows, (rowName, rowData) => {
          html += `
            <div class="c-wizard-qtn-summary-column o-layout__item o-layout__item--3">
              ${rowName.match(/-percent-?/) ? `${rowData.val}%` : rowData.val}
            </div>`;
        });

        html += '</div></div>';
      });

      html += '</div></div>';
    }

    return html;
  }

  /*
    This function will render questinnaire summary html table
  */
  renderSummary() {
    let html = '';
    const benePrimaryRows = [];
    const beneSecondaryRows = [];

    $.each(this.qtnFormFieldsForSummary, (i, el) => {
      $.each(el, (name, data) => {
        if (name.match(/^qtn-bene-(.+)/)) {
          const benePrimary = name.match(/bene-primary/);
          const beneSecondary = name.match(/bene-secondary/);

          if (benePrimary || beneSecondary) {
            let beneNumber = name.match(/bene-primary-(.+)-([0-9])$/);
            let beneRows = benePrimaryRows;
            const indexNext = parseInt(i, 10) + 1;
            const [nextName] = Object.keys(
              this.qtnFormFieldsForSummary[indexNext],
            );
            let showBene =
              !nextName.match(/^qtn-bene-primary-(.+)/) &&
              name.match(/^qtn-bene-primary-(.+)/);
            let beneType = 'primary';

            if (beneSecondary) {
              beneNumber = name.match(/bene-secondary-(.+)-([0-9])$/);
              beneRows = beneSecondaryRows;
              showBene =
                !nextName.match(/^qtn-bene-secondary-(.+)/) &&
                name.match(/^qtn-bene-secondary-(.+)/);
              beneType = 'secondary';
            }

            if (beneNumber) {
              const index = beneNumber[2] - 1;
              if (typeof beneRows[index] === 'undefined') {
                beneRows[index] = {};
              }
              beneRows[index][name] = data;
            } else {
              if (typeof beneRows[0] === 'undefined') {
                beneRows[0] = {};
              }
              beneRows[0][name] = data;
            }

            if (showBene) {
              html += this.renderBeneSummary(beneRows, beneType);
            }
          }
        } else {
          html += `<div class="c-wizard-qtn-summary-row o-layout">
            <div class="c-wizard-qtn-summary-column c-wizard-qtn-summary-column--label o-layout__item o-layout__item--medium-6"><strong>${
              data.label
            }</strong></div>
            <div class="c-wizard-qtn-summary-column c-wizard-qtn-summary-column--value o-layout__item o-layout__item--medium-6">${
              data.val
            }</div>
          </div>`;
        }
      });
    });

    this.qtnSummary.html(html);
  }

  /*
    This function will toggle offers list filters visibility on mobiel deviced
  */
  filtersToggle() {
    this.filterToggleButton.on('click', e => {
      const button = $(e.currentTarget);

      button.toggleClass('is-active');
      button
        .closest('.js-wizard-filter')
        .find('.js-wizard-filter-option')
        .toggleClass('is-open');
    });
  }

  /*
    This function will set current wizard step
  */
  getCurrentStep() {
    this.currentStep = this.steps.find('.js-wizard-step.is-active');
  }

  getCurrentStepNumber() {
    this.getCurrentStep();
    return this.currentStep.length
      ? this.currentStep.attr('data-wizard-step')
      : null;
  }

  /*
    This function will set wizard next step element
  */
  setNextStep(step) {
    this.nextStep = this.steps.find(
      `.js-wizard-step[data-wizard-step="${step}"]`,
    );

    this.wizard.removeClass((index, classname) =>
      (classname.match(/is-step-[0-9]/) || []).join(' '),
    );

    this.wizardPattern.removeClass((index, classname) =>
      (classname.match(/is-step-[0-9]/) || []).join(' '),
    );

    const nextStepNumber = this.nextStep.data('wizard-step');

    if (this.nextStep.length) {
      this.wizard.addClass(`is-step-${nextStepNumber}`);
    }

    if (this.wizardPattern.length) {
      this.wizardPattern.addClass(`is-step-${nextStepNumber}`);
    }
  }

  setStepBack(step) {
    this.stepBackButton.attr('data-wizard-step-back', step);
  }

  goStepBack() {
    this.stepBackButton.on('click', e => {
      const self = $(e.currentTarget);
      const goBackStepNumber = self.attr('data-wizard-step-back');
      const goBackToStep = this.steps.find(
        `.js-wizard-step[data-wizard-step="${goBackStepNumber}"]`,
      );
      const goBackStepIndex = this.wizardStepsOrder.indexOf(
        `${goBackStepNumber}`,
      );

      if (goBackStepIndex === -1) {
        return;
      }

      if (
        goBackStepIndex === 0 ||
        (this.isInstantQuote && goBackStepIndex === 1)
      ) {
        this.stepBackButton.hide();
      }

      const currentStepNumber = this.wizardStepsOrder[goBackStepIndex + 1];
      const leaveStep = this.steps.find(
        `.js-wizard-step[data-wizard-step="${currentStepNumber}"]`,
      );
      const newBackStepNumber = this.wizardStepsOrder[goBackStepIndex - 1];

      if (currentStepNumber === '3') {
        if (this.coverageSliderObject && this.coverageSliderObject.length) {
          this.coverageSliderObject.slider('destroy');
        }
      }

      leaveStep.fadeOut(500, () => {
        leaveStep.removeClass('is-active');

        if (typeof newBackStepNumber !== 'undefined') {
          this.setStepBack(newBackStepNumber);
        }

        goBackToStep.addClass('is-active');

        if (this.isCompare && this.getCurrentStepNumber() === '3') {
          this.stepBackButton.hide();
        }

        goBackToStep.fadeIn(500, () => {
          this.setNextStep(currentStepNumber);
        });
      });
    });
  }

  /*
    This function will scroll to the top of the wizard steps container
  */
  scrollUp() {
    $('body, html')
      .stop()
      .animate(
        {
          scrollTop: this.steps.offset().top - 100,
        },
        500,
      );
  }

  /*
    This function will calculate recommended quote values for the learning wizard path
  */
  wizardSetRecommendations(data) {
    const { children, benefits, debts, needs, resources } = data;

    let incomeMultiplier = '';
    const obligations = [];
    let recommendedLength = 30;
    let recommendedCoverageValue = 100000;
    let childrenObligations = '';

    // const { age } = info;

    if (children.ages.length && children.education.length) {
      childrenObligations = children.education.reduce(
        (a, b) => parseInt(a, 10) + parseInt(b, 10),
        0,
      );
      // const youngestChild = Math.min(...children.ages);
      childrenObligations /= children.ages.length; // divide
      // incomeMultiplier = 18 - youngestChild; // years to graduate
      // childrenObligations *= incomeMultiplier;

      // obligations.push(childrenObligations * incomeMultiplier);
    } else {
      // incomeMultiplier = 65 - age;
      // if (age < 55) {
      //   recommendedLength = [10, 15, 20][Math.floor(Math.random() * 3)];
      // } else {
      //   recommendedLength = [10, 15][Math.floor(Math.random() * 2)];
      // }
    }

    // new multiplier based on beneficiary support years
    incomeMultiplier = benefits.beneficiaryYears;

    childrenObligations *= incomeMultiplier;

    const incomeObligations =
      benefits.annualIncome * benefits.beneficiaryPercentage * incomeMultiplier;
    const debtsObligations =
      typeof debts.mortgage !== 'undefined'
        ? parseInt(debts.mortgage, 10) + parseInt(debts.other, 10)
        : 0;
    const needsObligations =
      parseInt(needs.funeralExpenses, 10) + parseInt(needs.otherExpenses, 10);

    // if (debtsObligations > 0) {
    //   recommendedLength = [25, 30][Math.floor(Math.random() * 2)];
    // }

    obligations.push(
      childrenObligations,
      incomeObligations,
      debtsObligations,
      needsObligations,
    );

    const resourcesAssets =
      parseInt(resources.currentCoverage, 10) + parseInt(resources.savings, 10);

    const total = obligations.reduce((a, b) => a + b, 0) - resourcesAssets;

    const coverageValues = Object.keys(this.coverageValues);
    // const recommendedCoverageValue = coverageValues.reduce(
    //   (a, b) => (Math.abs(b - total) < Math.abs(a - total) ? b : a),
    // );
    if (coverageValues.length) {
      // coverageValues = coverageValues.map(value => parseInt(value, 10));

      const highestCoverage = Math.max(...coverageValues);
      const lowestCoverage = Math.min(...coverageValues);

      if (total >= highestCoverage) {
        recommendedCoverageValue = `${highestCoverage}`;
      } else if (total <= lowestCoverage) {
        recommendedCoverageValue = `${lowestCoverage}`;
      } else {
        // get closest upper value
        recommendedCoverageValue = coverageValues.reduce((a, b) => {
          if (Math.abs(b - total) < Math.abs(a - total)) {
            return b >= total ? b : a;
          }

          return a;
        });
      }
    }

    // 10 for all
    recommendedLength = 10;

    const termValues = this.termValues[recommendedLength];
    const recommendedTermValue =
      termValues[Math.floor(Math.random() * termValues.length)];

    this.quoteParams.faceAmount = recommendedCoverageValue;
    this.quoteParams.category = recommendedTermValue;
    this.formFields['wizard-coverage'] = recommendedCoverageValue;
    this.formFields['wizard-term'] = recommendedTermValue;

    this.recommendedData.debt = debtsObligations;
    this.recommendedData.education = childrenObligations;
    this.recommendedData.support = incomeObligations;
    this.recommendedData.needs = needsObligations;
    this.recommendedData.resources = resourcesAssets;
  }

  /*
    This function will display an unexpected error and ask to refresh the page and try again
  */
  displayGeneraError() {
    const errorMessage = $(`<div class="c-wizard-error">
      <h5>${this.generalErrorMsg}</h5>
    </div>`);

    this.loader.html(errorMessage);
  }

  /*
    This function will prepare data for infusionsoft request from formFields and quoteParams data
  */
  prepareDataForInfusionsoft() {
    if (typeof this.quoteParams.province !== 'undefined') {
      for (let i = 0; i < this.provinceOptions.length; i += 1) {
        if (this.provinceOptions[i].value === this.quoteParams.province) {
          this.infusionsoftData.customFields.province = this.provinceOptions[
            i
          ].label;
        }
      }
    }

    if (typeof this.quoteParams.faceAmount !== 'undefined') {
      for (let i = 0; i < this.coverageOptions.length; i += 1) {
        if (this.coverageOptions[i].value === this.quoteParams.faceAmount) {
          this.infusionsoftData.customFields.coverage_amount = this.coverageOptions[
            i
          ].label;
        }
      }
    }

    if (typeof this.quoteParams.category !== 'undefined') {
      for (let i = 0; i < this.termOptions.length; i += 1) {
        if (this.termOptions[i].value === this.quoteParams.category) {
          this.infusionsoftData.customFields.policy_length = this.termOptions[
            i
          ].label;
        }
      }
    }

    this.infusionsoftData.customFields.sex =
      this.formFields['wizard-sex'] === '1' ? 'Male' : 'Female';
    this.infusionsoftData.customFields.smoker =
      this.formFields['wizard-smoker'] === '1' ? 'Smoker' : 'Non-Smoker';
    this.infusionsoftData.customFields.insurance_type = this.insuranceType;
    // this.infusionsoftData.customFields.quote_progress = this.quoteProgress;

    if (
      typeof this.offerAppliedFor.company !== 'undefined' &&
      typeof this.offerAppliedFor.premium !== 'undefined'
    ) {
      this.infusionsoftData.customFields.quote_company = this.offerAppliedFor.company;
      this.infusionsoftData.customFields.quote_premium = this.offerAppliedFor.premium;
    }

    if (Object.keys(this.partnerFormFields).length) {
      this.infusionsoftData.customFields.partner_birthday = this.partnerFormFields[
        'wizard-partner-dob'
      ];
      this.infusionsoftData.customFields.partner_sex =
        this.partnerFormFields['wizard-partner-sex'] === '1'
          ? 'Male'
          : 'Female';
      this.infusionsoftData.customFields.partner_smoker =
        this.partnerFormFields['wizard-partner-smoker'] === '1'
          ? 'Smoker'
          : 'Non-Smoker';
    }

    if (this.quoteResume.link) {
      this.infusionsoftData.customFields.resume_quote_url = this.quoteResume.link;
    }

    if (this.gclid) {
      this.infusionsoftData.customFields.gclid = this.gclid;
    }

    this.infusionsoftData.Birthday = this.formFields['wizard-dob'];
    this.infusionsoftData.Email = this.formFields['wizard-email'];

    // const fullName = this.formFields['wizard-name'];
    // const names = fullName.split(' ');
    this.infusionsoftData.FirstName = this.formFields['wizard-first-name'];
    this.infusionsoftData.LastName = this.formFields['wizard-last-name'];

    if (Object.keys(this.qtnFormFields).length) {
      this.infusionsoftData.FirstName = this.qtnFormFields['qtn-first-name'];
      this.infusionsoftData.LastName = this.qtnFormFields['qtn-last-name'];
      this.infusionsoftData.Email = this.qtnFormFields['qtn-email'];
      this.infusionsoftData.Phone1 = this.qtnFormFields['qtn-phone'];

      if (Object.keys(this.partnerFormFields).length) {
        this.infusionsoftData.customFields.partner_name = `${
          this.qtnFormFields['qtn-partner-first-name']
        } ${this.qtnFormFields['qtn-partner-last-name']}`;
        this.infusionsoftData.customFields.partner_email = this.qtnFormFields[
          'qtn-partner-email'
        ];
      }
    }
    // [this.infusionsoftData.FirstName, this.infusionsoftData.LastName] = names;
  }

  /*
    This function will prepare data for sendign via email from formFields and quoteParams data
  */
  prepareDataForEmail() {
    if (Object.keys(this.resumeQuotedata).length) {
      const {
        coverage,
        dob,
        email,
        first_name: firstName,
        last_name: lastName,
        phone,
        policy_length: policyLength,
        province,
        rates,
        sex,
        smoker,
      } = this.resumeQuotedata;

      this.formFields['wizard-email'] = email;
      this.formFields['wizard-first-name'] = firstName;
      this.formFields['wizard-last-name'] = lastName;
      this.formFields['wizard-phone'] = phone || '';

      this.emailData.coverage_amount = coverage;
      this.emailData.dob = dob;
      this.emailData.email = email;
      this.emailData.first_name = firstName;
      this.emailData.last_name = lastName;
      this.emailData.phone = phone || '';
      this.emailData.policy_length = policyLength;
      this.emailData.province = province;
      this.quoteProgress = this.quoteProgressLabels.resume;
      this.emailData.rates = rates;
      this.emailData.sex = sex;
      this.emailData.smoker = smoker;
      this.emailData.subject = this.insuranceType;

      return;
    }

    this.emailData.province = '';
    this.emailData.coverage_amount = '';
    this.emailData.policy_length = '';

    if (typeof this.quoteParams.province !== 'undefined') {
      for (let i = 0; i < this.provinceOptions.length; i += 1) {
        if (this.provinceOptions[i].value === this.quoteParams.province) {
          this.emailData.province = this.provinceOptions[i].label;
        }
      }
    }

    if (typeof this.quoteParams.faceAmount !== 'undefined') {
      for (let i = 0; i < this.coverageOptions.length; i += 1) {
        if (this.coverageOptions[i].value === this.quoteParams.faceAmount) {
          this.emailData.coverage_amount = this.coverageOptions[i].label;
        }
      }
    }

    if (typeof this.quoteParams.category !== 'undefined') {
      for (let i = 0; i < this.termOptions.length; i += 1) {
        if (this.termOptions[i].value === this.quoteParams.category) {
          this.emailData.policy_length = this.termOptions[i].label;
        }
      }
    }

    this.emailData.sex =
      this.formFields['wizard-sex'] === '1' ? 'Male' : 'Female';
    this.emailData.smoker =
      this.formFields['wizard-smoker'] === '1' ? 'Smoker' : 'Non-Smoker';
    this.emailData.rates =
      this.formFields['wizard-mode'] === 2 ? 'Monthly' : 'Yearly';
    this.emailData.subject = this.insuranceType;
    this.emailData.quote_progress = this.quoteProgress;

    if (Object.keys(this.partnerFormFields).length) {
      this.emailData.partner = {
        dob: this.partnerFormFields['wizard-partner-dob'],
        sex:
          this.partnerFormFields['wizard-partner-sex'] === '1'
            ? 'Male'
            : 'Female',
        smoker:
          this.partnerFormFields['wizard-partner-smoker'] === '1'
            ? 'Smoker'
            : 'Non-Smoker',
      };
    }

    this.emailData.dob = this.formFields['wizard-dob'];
    this.emailData.email = this.formFields['wizard-email'];
    this.emailData.phone = this.formFields['wizard-phone'] || '';
    this.emailData.contact_method = this.formFields['wizard-contact-via'] || '';

    this.emailData.first_name = this.formFields['wizard-first-name'];
    this.emailData.last_name = this.formFields['wizard-last-name'];

    if (Object.keys(this.qtnFormFields).length) {
      this.emailData.first_name = this.qtnFormFields['qtn-first-name'];
      this.emailData.last_name = this.qtnFormFields['qtn-last-name'];
      this.emailData.email = this.qtnFormFields['qtn-email'];
      this.emailData.phone = this.qtnFormFields['qtn-phone'];

      if (Object.keys(this.partnerFormFields).length) {
        this.emailData.partner.first_name = this.qtnFormFields[
          'qtn-partner-first-name'
        ];
        this.emailData.partner.last_name = this.qtnFormFields[
          'qtn-partner-last-name'
        ];
        this.emailData.partner.email = this.qtnFormFields['qtn-partner-email'];
      }
    }
  }

  /*
    This function will show thank you step and display the message
  */
  displayQuoteThankYou() {
    this.nextStep.fadeIn(500, () => {
      this.hideLoader();
      this.nextStep.addClass('is-active');
    });
  }

  /*
    This function will manage rates filter radio buttons change event
  */
  modeFilterChange(radios, value, currentValueElement, filter) {
    this.f = filter;
    const radioChecked = this.f.find(`input[type="radio"][value="${value}"]`);

    if (radioChecked.length) {
      radios.removeAttr('checked');
      radioChecked.prop('checked', true);
      currentValueElement.text(
        radioChecked
          .parent()
          .find('.js-radio-label')
          .text(),
      );
    }
  }

  /*
    This function will format price to display currency
  */
  formatPrice(price) {
    const preparedPrice = `${price}`.replace(/\$/, '');
    const formattedPrice = new Intl.NumberFormat(
      this.locale.replace('_', '-'),
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    ).format(preparedPrice);
    return `${this.currency}${formattedPrice}`;
  }

  formatDate(date) {
    const formattedDate = new Intl.DateTimeFormat(
      this.locale.replace('_', '-'),
      { month: 'long', day: 'numeric', year: 'numeric' },
    ).format(date);

    return formattedDate;
  }

  /*
    This function will convert camel case (cC) string to kebab case (-) string
  */
  static camelToKebabCase(string) {
    return string.replace(/[\w]([A-Z])/g, m => `${m[0]}-${m[1]}`).toLowerCase();
  }

  static prepareOffers(offers) {
    return offers.filter(offer => {
      const offerObject = offer;
      const { premium } = offerObject;
      offerObject.premium = parseFloat(`${premium}`.replace(/[^0-9.]/, ''));
      return offerObject;
    });
  }

  /*
    This function will scroll page to offers list
  */
  scrollToOffers() {
    $('body, html')
      .stop()
      .animate(
        {
          scrollTop: this.offersContainer.offset().top - 150,
        },
        700,
      );
  }

  /*
    This function will toggle compare button visibility depending on offers number selected for comparison
  */
  toggleCompareButton() {
    const checkboxesChecked = this.offersContainer.find(
      '.js-wizard-offer-compare input[type="checkbox"]:checked:visible',
    );

    if (checkboxesChecked.length > 1) {
      this.compareOffersButton
        .addClass('show')
        .find('span')
        .text(`(${checkboxesChecked.length})`);
    } else {
      this.compareOffersButton
        .removeClass('show')
        .find('span')
        .text('');
    }
  }

  /*
    This function will set active dots for the compare table owl carousel items
  */
  setActiveDots(currentIndex) {
    const items = this.compareTableData.find('.owl-item.active').length;
    let start = currentIndex - items + 1 < 0 ? 0 : currentIndex - items + 1;
    let end = currentIndex;
    const dots = this.compareTableData.find('.owl-dots');

    if (currentIndex === -1) {
      start = 0;
      end = items - 1;
    }

    if (start !== currentIndex) {
      dots.find('.owl-dot').removeClass('active');
      for (let i = start; i <= end; i += 1) {
        const dot = dots.find('.owl-dot').eq(i);

        if (dot.length) {
          setTimeout(() => {
            dot.addClass('active');
          });
        }
      }
    }

    if (end < items - 1) {
      const fromEnd = items - 1 - end;
      for (let i = 1; i <= fromEnd; i += 1) {
        const dot = dots.find('.owl-dot').eq(-i);

        if (dot.length) {
          setTimeout(() => {
            dot.addClass('active');
          });
        }
      }
    }
  }

  /*
    This function will set compare offers table rows to the same height
  */
  setCompareTableRowsHeight() {
    const columns = this.compareTable.find('.js-wizard-compare-table-column');

    const rowsHeights = [];

    if (columns.length) {
      $.each(columns, (index, el) => {
        const column = $(el);
        const rows = column.find('.js-wizard-compare-table-row');

        if (rows.length) {
          $.each(rows, (i, elem) => {
            const row = $(elem);

            if (typeof rowsHeights[i] === 'undefined') {
              rowsHeights[i] = [];
            }
            rowsHeights[i].push(row.outerHeight());
          });
        }
      });

      if (rowsHeights.length) {
        $.each(columns, (index, el) => {
          const column = $(el);

          for (let i = 0; i < rowsHeights.length; i += 1) {
            const rowHeights = rowsHeights[i] || [];
            const rowMaxHeight = Math.max(...rowHeights);
            const row = column.find('.js-wizard-compare-table-row').eq(i);

            if (row.length) {
              row.css({ minHeight: rowMaxHeight });
            }
          }
        });
      }
    }
  }

  /*
    This function will set questionnaire current, previous and next steps elements
  */
  setQtnSteps() {
    this.qtnCurrentStep = this.qtnForm.find(
      '.js-wizard-qtn-form-step.is-active',
    );
    this.qtnPrevStep = this.qtnCurrentStep.prev('.js-wizard-qtn-form-step');
    this.qtnNextStep = this.qtnCurrentStep.next('.js-wizard-qtn-form-step');

    const timeLeft = this.qtnCurrentStep.data('qtn-time-left');

    if (typeof timeLeft !== 'undefined') {
      const minutesText = timeLeft === 1 ? this.minuteText : this.minutesText;

      this.qtnTimeLeft
        .show()
        .find('strong')
        .text(`${timeLeft} ${minutesText}`);
    } else {
      this.qtnTimeLeft.hide();
    }
  }

  /*
    This function will validate questinnaire form fields via ajax
  */
  qtnStepValidate() {
    if (this.submitting) {
      return;
    }

    this.showLoader('');
    $.post(
      this.ajaxurl,
      {
        action: 'x5_wizard_qtn_form_validation',
        security: this.formSecurityNonce,
        fields: this.qtnFormFields,
        fieldsTypes: this.qtnFormFieldsTypes,
        fieldsOptional: this.qtnFormFieldsOptional,
      },
      response => {
        if (response.ok) {
          this.saveQuoteResumeData('qtn')
            .done(result => {
              if (result.ok) {
                this.qtnGoToNextStep();
              } else {
                this.displayGeneraError();
              }
            })
            .fail(() => {
              this.displayGeneraError();
            });
        } else if (response.error) {
          if (response.errors) {
            this.hideLoader();
            this.submitting = false;

            $.each(response.errors, (name, errorMsg) => {
              let field = null;

              if (name === 'bene-primary' || name === 'bene-secondary') {
                field = this.qtnForm.find(`.js-form-repeater-${name}`);
              } else {
                field = this.qtnForm.find(`[name="${name}"]`);
              }
              const error = $(
                `<p class="c-wizard-field__error js-wizard-field-error">${errorMsg}</p>`,
              );

              if (field.length) {
                if (field.closest('.c-form__control--radio').length) {
                  error
                    .addClass('is-top-error')
                    .insertBefore(field.closest('.c-form__control--radio'));
                } else if (
                  name === 'bene-primary' ||
                  name === 'bene-secondary'
                ) {
                  field
                    .parent()
                    .find('h4')
                    .first()
                    .append(error);
                } else {
                  field.parent().append(error);
                }
              }
            });

            $('body, html')
              .stop()
              .animate(
                {
                  scrollTop:
                    this.qtnForm
                      .find('.js-wizard-field-error')
                      .first()
                      .offset().top - 150,
                },
                500,
              );
          } else {
            this.displayGeneraError();
          }
        }
      },
    ).fail((xhr, status, error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      this.displayGeneraError();
    });

    this.submitting = true;
  }

  /*
    This function will move to the next step of the questionnaire
  */
  qtnGoToNextStep() {
    this.stepBackButton.hide();

    this.qtnForm.stop().animate({ opacity: 0 }, 500, () => {
      if (this.qtnNextStep.length) {
        this.qtnCurrentStep.removeClass('is-active').addClass('is-past');
        this.qtnNextStep.removeClass('is-past').addClass('is-active');

        this.setQtnSteps();
        // this.setQtnSubmitBtn();
        this.setQtnProgressBar();
        this.qtnPrefillFields();

        this.qtnFormBackBtn.toggle(this.qtnPrevStep.length > 0);
        this.qtnFormBtn.toggle(this.qtnNextStep.length > 0);
        this.qtnProgressBar.removeClass('is-backwards').addClass('is-forward');

        this.hideLoader();
        this.submitting = false;

        $('body, html')
          .stop()
          .animate(
            {
              scrollTop: this.qtnProgressBar.offset().top - 100,
            },
            500,
            () => {
              this.qtnForm.stop().animate({ opacity: 1 }, 500);
            },
          );
      }
    });
  }

  /*
    This function will manage questionnaire progress bar state
  */
  setQtnProgressBar() {
    const currentStep = this.qtnCurrentStep.data('qtn-form-step');
    const prevStep = this.qtnPrevStep.data('qtn-form-step');
    const nextStep = this.qtnNextStep.data('qtn-form-step');

    const barCurrenStep = this.qtnProgressBar.find(
      `.js-wizard-qtn-progress-bar-step[data-qtn-bar-step=${currentStep}]`,
    );
    const barPrevStep = this.qtnProgressBar.find(
      `.js-wizard-qtn-progress-bar-step[data-qtn-bar-step=${prevStep}]`,
    );
    const barNextStep = this.qtnProgressBar.find(
      `.js-wizard-qtn-progress-bar-step[data-qtn-bar-step=${nextStep}]`,
    );

    if (barPrevStep.length) {
      barPrevStep.removeClass('is-active').addClass('is-done');
    }

    if (barCurrenStep.length) {
      barCurrenStep.addClass('is-active').removeClass('is-done');
    }

    if (barNextStep.length) {
      barNextStep.removeClass('is-active is-done');
    }
  }

  /*
    This function will prefill questionnaire form field with wizard form data values - fields with data-prefill attribute
  */
  qtnPrefillFields() {
    const fields = this.qtnForm.find('input:visible, select:visible');

    if (fields.length) {
      $.each(fields, (i, el) => {
        const field = $(el);
        const prefill = field.attr('data-prefill');

        if (
          typeof prefill !== 'undefined' &&
          typeof this.formFields[prefill] !== 'undefined'
        ) {
          if (field.is('input[type="radio"]')) {
            if (field.val() === this.formFields[prefill]) {
              field.prop('checked', true);
            }
          } else {
            field.val(this.formFields[prefill]).trigger('input');
          }
        }
      });
    }
  }
}

export default new Wizard();



// WEBPACK FOOTER //
// ./src/scripts/modules/wizard.js